
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("j1Hga", function(module, exports) {
/* charlie-table.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hvpsn = parcelRequire("hvpsn");

var $bVEgZ = parcelRequire("bVEgZ");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");


var $9hlns = parcelRequire("9hlns");


var $fmn3m = parcelRequire("fmn3m");

/* charlie-table.types.ts generated by @compiled/babel-plugin v0.36.1 */ const $ed0a2f88b068d47d$export$2a6d2126c26a0f80 = {
    success: 'success',
    danger: 'danger',
    information: 'information',
    discovery: 'discovery',
    warning: 'warning',
    selected: 'selected',
    disabled: 'disabled'
};
const $ed0a2f88b068d47d$export$ec659152c0ce3638 = {
    inventory: 'INVENTORY',
    input: 'INPUT'
};


/* charlie-table-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gHR9M = parcelRequire("gHR9M");

const $91935a6899fcbe2a$export$994a566b22e1207 = ({ enableRowVirtualization: enableRowVirtualization, table: table, tableContainerRef: tableContainerRef, rowSpacing: rowSpacing, rowVirtualizerRef: rowVirtualizerRef, rowVirtualizerOptions: rowVirtualizerOptions })=>{
    /**
	 * This theoretically breaks the rule of hooks but the prop can't be changed after the table is rendered
	 * so in practice it's fine
	 */ if (!enableRowVirtualization) return undefined;
    const customRowVirtualizerOptions = typeof rowVirtualizerOptions === 'function' ? rowVirtualizerOptions({
        table: table
    }) : rowVirtualizerOptions;
    const { rows: rows } = table.getRowModel();
    const rowHeight = rowSpacing === 'compact' ? 38 : 46;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const rowVirtualizer = (0, $gHR9M.useVirtualizer)({
        count: rows.length,
        getScrollElement: ()=>tableContainerRef?.current,
        //measure dynamic row height, except in firefox because it measures table border height incorrectly
        measureElement: typeof window !== 'undefined' && navigator.userAgent.indexOf('Firefox') === -1 ? (element)=>element?.getBoundingClientRect().height : undefined,
        estimateSize: ()=>rowHeight,
        overscan: 10,
        ...customRowVirtualizerOptions
    });
    if (rowVirtualizerRef) rowVirtualizerRef.current = rowVirtualizer;
    return rowVirtualizer;
};


/* body.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















const $7146819932c31f8d$export$7005b8a93a167348 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "tbody",
        ...props,
        ref: ref,
        children: children
    }));


const $ed7b2e09c17a13fe$var$styles = {
    body: "_19itglyw _kqswh2mm _1e0c11p5"
};
const $ed7b2e09c17a13fe$export$7005b8a93a167348 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, xcss: xcss, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7146819932c31f8d$export$7005b8a93a167348), {
        xcss: (0, $1Whri.cx)($ed7b2e09c17a13fe$var$styles.body, xcss),
        ref: ref,
        ...props,
        children: children
    });
});


/* data-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















/* reserved-column.utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $7gpC4 = parcelRequire("7gpC4");




const $b2fd1883fd0c654d$var$handleRowSelection = ({ row: row, table: table, lastSelectedRowIdRef: lastSelectedRowIdRef, event: event })=>{
    event.stopPropagation();
    const wasCurrentRowChecked = row.getIsSelected();
    // Toggle selection of this row
    row.toggleSelected();
    // If shift key is pressed and we have a last selected row, select range
    if (lastSelectedRowIdRef && lastSelectedRowIdRef.current !== null && event.nativeEvent.shiftKey) {
        const rows = table.getRowModel().rows;
        const lastIndex = rows.findIndex((r)=>r.id === lastSelectedRowIdRef.current);
        const currentIndex = rows.findIndex((r)=>r.id === row.id);
        if (lastIndex !== -1 && currentIndex !== -1) {
            const isLastIndexChecked = rows[lastIndex]?.getIsSelected() ?? false;
            const [start, end] = lastIndex < currentIndex ? [
                lastIndex,
                currentIndex
            ] : [
                currentIndex,
                lastIndex
            ];
            // Toggle selection of all rows between last selected and this one
            // but only if the last selected row is not the same as the current one
            if (wasCurrentRowChecked !== isLastIndexChecked) {
                for(let i = start; i <= end; i++)if (rows[i]) rows[i].toggleSelected(!wasCurrentRowChecked);
            }
        }
    }
    // Record the last selected row id
    if (lastSelectedRowIdRef) lastSelectedRowIdRef.current = row.id;
};
const $b2fd1883fd0c654d$var$styles = {
    checkboxContainer: "_4cvr1h6o _1ul91ady"
};
const $b2fd1883fd0c654d$var$reservedPrefix = 'charlie-table-reserved-';
const $b2fd1883fd0c654d$export$a8fe87a68ec18bbd = {
    CHECKBOX: `${$b2fd1883fd0c654d$var$reservedPrefix}checkbox`,
    DRAG_HANDLE: `${$b2fd1883fd0c654d$var$reservedPrefix}drag-handle`
};
const $b2fd1883fd0c654d$export$ea0bd2a363b278a7 = {
    checkbox: 44,
    dragHandle: 32
};
function $b2fd1883fd0c654d$export$c4724ea5fd313554({ reservedColumns: reservedColumns, originalColumns: originalColumns = [] }) {
    const enabledReservedColumns = reservedColumns.filter((config)=>config.enabled);
    const enabledReservedColumnIds = enabledReservedColumns.map((config)=>config.id);
    // Separate columns by position
    const startColumns = enabledReservedColumns.filter((config)=>config.position === 'start' || !config.position).map((config)=>config.columnDef);
    const endColumns = enabledReservedColumns.filter((config)=>config.position === 'end').map((config)=>config.columnDef);
    // Build modified columns array
    const modifiedColumns = [
        ...startColumns,
        ...originalColumns,
        ...endColumns
    ];
    // Utility function to append reserved column IDs to lists
    const appendReservedColumnsToList = (list)=>{
        if (enabledReservedColumnIds.length === 0 || !list) return list;
        const newList = [
            ...list
        ];
        const startColumnIds = enabledReservedColumns.filter((config)=>config.position === 'start' || !config.position).map((config)=>config.id);
        const endColumnIds = enabledReservedColumns.filter((config)=>config.position === 'end').map((config)=>config.id);
        enabledReservedColumnIds.forEach((id)=>{
            const index = newList.indexOf(id);
            if (index !== -1) newList.splice(index, 1);
        });
        if (startColumnIds.length > 0) newList.unshift(...startColumnIds);
        if (endColumnIds.length > 0) newList.push(...endColumnIds);
        return newList;
    };
    return {
        modifiedColumns: modifiedColumns,
        enabledReservedColumnIds: enabledReservedColumnIds,
        utils: {
            appendReservedColumnsToList: appendReservedColumnsToList
        }
    };
}
function $b2fd1883fd0c654d$export$1bb60ea325c29252(reservedColumnResult, states, initialStates = {}) {
    const { utils: utils } = reservedColumnResult;
    return {
        modifiedColumnOrder: utils.appendReservedColumnsToList(states.columnOrder),
        modifiedInitialColumnOrder: utils.appendReservedColumnsToList(initialStates.columnOrder),
        modifiedColumnPinningLeft: utils.appendReservedColumnsToList(states.columnPinningLeft),
        modifiedInitialColumnPinningLeft: utils.appendReservedColumnsToList(initialStates.columnPinningLeft)
    };
}
function $b2fd1883fd0c654d$export$d5bdb168897a18dd({ id: id, feature: feature, position: position = 'start', customFeatureSizes: customFeatureSizes = {}, labels: labels, analyticsContext: analyticsContext, lastSelectedRowIdRef: lastSelectedRowIdRef }) {
    const featureSizes = {
        ...$b2fd1883fd0c654d$export$ea0bd2a363b278a7,
        ...customFeatureSizes
    };
    const totalSize = featureSizes[feature];
    const headerRenderer = ({ table: table })=>{
        if (feature === 'checkbox') return /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
            analyticsContext: analyticsContext ? {
                componentName: 'charlieTableSelectAllRowsButton',
                ...analyticsContext
            } : undefined,
            "aria-label": labels?.selectAllRows || 'Select all rows',
            isIndeterminate: table.getIsSomeRowsSelected(),
            isChecked: table.getIsAllRowsSelected(),
            onClick: ()=>table.toggleAllRowsSelected()
        });
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {});
    };
    const cellRenderer = (context)=>{
        const { row: row, table: table } = context;
        if (feature === 'checkbox') {
            const isSomeSelected = row.getIsSomeSelected();
            const isAllSubRowsSelected = row.getIsAllSubRowsSelected();
            const isSelected = row.getIsSelected();
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                xcss: $b2fd1883fd0c654d$var$styles.checkboxContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                    analyticsContext: analyticsContext ? {
                        componentName: 'charlieTableSelectRowButton',
                        ...analyticsContext
                    } : undefined,
                    "aria-label": labels?.selectRow || 'Select row',
                    isDisabled: !row.getCanSelect(),
                    isIndeterminate: isSomeSelected && !isAllSubRowsSelected,
                    isChecked: isSelected || isAllSubRowsSelected,
                    onClick: (e)=>{
                        $b2fd1883fd0c654d$var$handleRowSelection({
                            row: row,
                            table: table,
                            lastSelectedRowIdRef: lastSelectedRowIdRef,
                            event: e
                        });
                    }
                })
            });
        }
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {});
    };
    const columnDef = {
        header: headerRenderer,
        id: id,
        size: Math.max(totalSize, 32),
        // Minimum size of 32px
        minSize: Math.max(totalSize, 32),
        enableSorting: false,
        enableResizing: false,
        cell: cellRenderer
    };
    return {
        id: id,
        enabled: true,
        position: position,
        columnDef: columnDef
    };
}
function $b2fd1883fd0c654d$export$f8b7ab5a32f0b337(columnId) {
    // TODO: Improve this quick and dirty check to see if the column is a reserved column.
    return columnId.startsWith($b2fd1883fd0c654d$var$reservedPrefix);
}
function $b2fd1883fd0c654d$export$75de7ce71826ef0b(columns) {
    return columns.findIndex((column)=>!$b2fd1883fd0c654d$export$f8b7ab5a32f0b337(column.id));
}
function $b2fd1883fd0c654d$export$355ef7276abf9248(columns, columnIndex) {
    const firstNonReservedIndex = $b2fd1883fd0c654d$export$75de7ce71826ef0b(columns);
    return columnIndex === firstNonReservedIndex;
}


/* pragmatic-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $2n8po = parcelRequire("2n8po");




function $7ff93f675da7135b$export$74665b213cb5c4cf(...refs) {
    return (0, $42omo.useCallback)((instance)=>{
        refs.forEach((ref)=>{
            if (ref) {
                if (typeof ref === 'function') ref(instance);
                else ref.current = instance;
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}






var $dRnqM = parcelRequire("dRnqM");


var $2WHHL = parcelRequire("2WHHL");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");

function $2c69f07036c8e9be$export$8a7a954d8c91183({ enabled: enabled, elementRef: elementRef, dropTargetRef: dropTargetRef, allowedEdges: allowedEdges, getData: getData, canDrop: canDrop, canMonitor: canMonitor, onDragStart: onDragStart, onDragEnter: onDragEnter, onDrag: onDrag, onDragLeave: onDragLeave, onDrop: onDrop, onDragEnd: onDragEnd, onGenerateDragPreview: onGenerateDragPreview, dependencies: dependencies = [] }) {
    (0, $42omo.useEffect)(()=>{
        if (!enabled) return;
        (0, $dRnqM.default)(elementRef.current);
        const element = elementRef.current;
        (0, $dRnqM.default)(element);
        const data = getData();
        return (0, $bSjaC.combine)((0, $4T4vf.draggable)({
            element: element,
            getInitialData () {
                return data;
            },
            onDragStart: ()=>{
                onDragStart?.();
            },
            onDrop: ()=>{
                onDragEnd?.();
                if (dropTargetRef?.current) dropTargetRef.current.style.display = 'none';
            }
        }), (0, $4T4vf.dropTargetForElements)({
            element: element,
            ...canDrop && {
                canDrop: canDrop
            },
            getData: ({ input: input })=>{
                return (0, $2WHHL.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            },
            onDragEnter (args) {
                const edge = (0, $2WHHL.extractClosestEdge)(args.self.data);
                onDragEnter?.(edge);
            },
            onDrag (args) {
                if (dropTargetRef?.current) dropTargetRef.current.style.display = 'block';
                const closestEdge = (0, $2WHHL.extractClosestEdge)(args.self.data);
                onDrag?.(closestEdge, args.source.element, element, args.source.data);
            },
            onDragLeave () {
                onDragLeave?.();
            },
            onDrop () {
                onDrop?.();
            }
        }), (0, $4T4vf.monitorForElements)({
            ...canMonitor && {
                canMonitor: canMonitor
            },
            onGenerateDragPreview () {
                onGenerateDragPreview?.();
                if (dropTargetRef?.current) dropTargetRef.current.style.display = 'block';
            },
            onDrop () {
                onDragEnd?.();
                if (dropTargetRef?.current) dropTargetRef.current.style.display = 'none';
            }
        }));
    }, [
        enabled,
        elementRef,
        dropTargetRef,
        getData,
        canDrop,
        canMonitor,
        onDragStart,
        onDragEnter,
        onDrag,
        onDragLeave,
        onDrop,
        onDragEnd,
        onGenerateDragPreview,
        allowedEdges,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...dependencies
    ]);
}


/**
 * Checks if two elements are within the same table
 * @param sourceElement - The source element from the drag event
 * @param selfElement - The current element (ref.current)
 * @returns true if both elements are within the same table
 */ const $45acf452ad2feb70$export$4ef518c7050e21b = (sourceElement, selfElement)=>{
    const sourceTable = sourceElement.closest('table');
    const selfTable = selfElement?.closest('table');
    return sourceTable === selfTable;
};


/* row.tsx generated by @compiled/babel-plugin v0.36.1 */ 











/* tr.tsx generated by @compiled/babel-plugin v0.36.1 */ 











const $625b1137a3549d0c$var$lastRowStyle = null; /**
                            * __Row__
                            *
                            * A row primitive.
                            *
                            * - [Examples](https://atlassian.design/components/table/examples)
                            */ 
const $625b1137a3549d0c$export$5582bd7183a5e873 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isSelected: isSelected, children: children, xcss: xcss, testId: testId, ...props }, ref)=>{
    const shapeThemeRefresh = (0, $dh538.fg)('charlie-table-shape-refresh');
    return /*#__PURE__*/ (0, $l998X.jsx)("tr", {
        className: (0, $gMc0m.default)([
            shapeThemeRefresh && "_80ykglyw",
            xcss
        ]),
        "data-testid": testId,
        tabIndex: -1,
        "aria-selected": isSelected,
        ref: ref,
        ...props,
        children: children
    });
});


const $568c5bbbe63cf60f$var$styles = {
    bodyRow: "_19itglyw _kqswh2mm _hpylidpf _btyzidpf _1e0c1txw _1bsb1osq _4cvr1h6o",
    compactRow: "",
    backgroundDefault: "_bfhkvuon",
    backgroundHovered: "_bfhk116u"
};
const $568c5bbbe63cf60f$export$b59bdbef9ce70de2 = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId, spacing: spacing, xcss: xcss, isSelected: isSelected, ...props }, ref)=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const handleMouseEnter = (event)=>{
        setIsHovered(true);
        (0, $dh538.fg)('charly-table-with-row-table-handler') && props.onMouseEnter?.(event);
    };
    const handleMouseLeave = (event)=>{
        setIsHovered(false);
        (0, $dh538.fg)('charly-table-with-row-table-handler') && props.onMouseLeave?.(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $625b1137a3549d0c$export$5582bd7183a5e873), {
        ref: ref,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        isSelected: isSelected,
        testId: testId,
        xcss: (0, $1Whri.cx)($568c5bbbe63cf60f$var$styles.bodyRow, spacing === 'compact' && $568c5bbbe63cf60f$var$styles.compactRow, isHovered ? $568c5bbbe63cf60f$var$styles.backgroundHovered : $568c5bbbe63cf60f$var$styles.backgroundDefault, xcss),
        ...props,
        children: children
    });
}));


const $550ed92b14c5bb3f$var$idleState = {
    type: 'idle'
};
const $550ed92b14c5bb3f$var$draggingState = {
    type: 'dragging'
};
const $550ed92b14c5bb3f$var$defaultAllowedEdges = [
    'bottom'
];
const $550ed92b14c5bb3f$var$dropIndicatorStyles = null;
const $550ed92b14c5bb3f$export$d1e11c43191d6f47 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, row: row, index: index, enableRowReorder: enableRowReorder = false, allowedEdges: allowedEdges = $550ed92b14c5bb3f$var$defaultAllowedEdges, ...rowProps }, ref)=>{
    const dropTargetRef = (0, $42omo.useRef)(null);
    const rowRef = (0, $42omo.useRef)(null);
    const [state, setState] = (0, $42omo.useState)($550ed92b14c5bb3f$var$idleState);
    const mergedRef = (0, $7ff93f675da7135b$export$74665b213cb5c4cf)(rowRef, ref);
    (0, $2c69f07036c8e9be$export$8a7a954d8c91183)({
        enabled: enableRowReorder,
        elementRef: rowRef,
        dropTargetRef: dropTargetRef,
        allowedEdges: allowedEdges,
        getData: ()=>({
                type: 'item-row',
                row: row,
                index: index,
                id: row.id
            }),
        canDrop: ({ source: source })=>source.data.type === 'item-row' && source.data.id !== row.id && (0, $45acf452ad2feb70$export$4ef518c7050e21b)(source.element, rowRef.current),
        canMonitor: ({ source: source })=>source.data.type === 'item-row' && (0, $45acf452ad2feb70$export$4ef518c7050e21b)(source.element, rowRef.current),
        onDragStart: ()=>{
            setState($550ed92b14c5bb3f$var$draggingState);
        },
        onDragEnter: (edge)=>{
            setState({
                type: 'is-over',
                closestEdge: edge
            });
        },
        onDrag: (closestEdge)=>{
            // only update react state if the `closestEdge` changes
            setState((current)=>{
                if (current.type !== 'is-over') return current;
                if (current.closestEdge === closestEdge) return current;
                return {
                    type: 'is-over',
                    closestEdge: closestEdge
                };
            });
        },
        onDragLeave: ()=>{
            setState($550ed92b14c5bb3f$var$idleState);
        },
        onDrop: ()=>{
            setState($550ed92b14c5bb3f$var$idleState);
        },
        onDragEnd: ()=>{
            setState($550ed92b14c5bb3f$var$idleState);
        },
        dependencies: [
            row,
            index
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $568c5bbbe63cf60f$export$b59bdbef9ce70de2), {
        ...rowProps,
        ref: mergedRef,
        draggable: enableRowReorder,
        children: [
            children,
            state.type === 'is-over' && state.closestEdge && enableRowReorder && /*#__PURE__*/ (0, $l998X.jsx)("td", {
                className: (0, $gMc0m.default)([
                    "_kqswstnw _snsvt94y _1ltvidpf _1xi2idpf _94n5t94y"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
                    edge: state.closestEdge,
                    type: "no-terminal"
                })
            })
        ]
    });
});



/* row-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 














/* base-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 











const $9866f5f0abd9e328$var$styles = {
    text: "_y3gn1e5h",
    icon: "_y3gn1h6o",
    number: "_y3gnusic"
};
const $9866f5f0abd9e328$var$baseStyles = null;
const $9866f5f0abd9e328$var$removeFirstChildTdReset = null; // When platform-dst-shape-theme-default: outer border is drawn by table wrapper; first/last cells get no outer border.
const $9866f5f0abd9e328$var$removeFirstChildTdResetShapeTheme = null;
const $9866f5f0abd9e328$var$removeFirstChildThReset = null;
const $9866f5f0abd9e328$var$removeFirstChildThResetShapeTheme = null;
const $9866f5f0abd9e328$var$lastColumnGrow = null; /**
                              * __BaseCell__
                              *
                              * @internal
                              *
                              * Basic cell element.
                              */ 
const $9866f5f0abd9e328$export$41ad0bbfa4755cac = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, as: Component = 'td', xcss: xcss, children: children, scope: scope, width: width, sortDirection: sortDirection, colSpan: colSpan, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, align: align, style: style, onKeyDown: onKeyDown, tabIndex: tabIndex, onMouseMove: onMouseMove, isOverridingResponsiveColumnSizing: isOverridingResponsiveColumnSizing }, ref)=>{
    const shapeThemeRefresh = (0, $dh538.fg)('charlie-table-shape-refresh');
    const isTd = Component === 'td';
    const isTh = Component === 'th';
    const tdWithShapeTheme = isTd && shapeThemeRefresh;
    const tdDefault = isTd && !shapeThemeRefresh;
    const thWithShapeTheme = isTh && shapeThemeRefresh;
    const thDefault = isTh && !shapeThemeRefresh;
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        ref: ref,
        scope: scope,
        tabIndex: tabIndex,
        onKeyDown: onKeyDown,
        style: {
            width: width ? `${width}px` : undefined,
            ...style
        },
        className: (0, $gMc0m.default)([
            "_19itglyw _1rjcu2gc _vchhusvi _r06hglyw _y4tiu2gc _7ehip0rx _mizu1r31 _ra3xglyw _128m1o36 _1ejjp0rx",
            tdWithShapeTheme && "_16aeu2gc _bbd3grho",
            thWithShapeTheme && "_16aeu2gc _gyfzu2gc",
            tdDefault && "_rqkyia51 _16aeu2gc _1975ia51 _bbd3e4h9",
            thDefault && "_rqkyia51 _16aeu2gc _1975ia51 _gyfzu2gc",
            align && $9866f5f0abd9e328$var$styles[align],
            (isTd || isTh) && !isOverridingResponsiveColumnSizing && "_94vikb7n",
            xcss
        ]),
        "data-testid": testId,
        "aria-sort": sortDirection,
        colSpan: colSpan,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        children: children
    });
});


const $cda138ee9fda43ce$export$9cf5b401f969f5e3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9866f5f0abd9e328$export$41ad0bbfa4755cac), {
        as: "td",
        testId: testId,
        ...props,
        ref: ref
    }));



const $56f1ec0b719310c0$var$cellBackgroundStyles = {
    success: "_bfhk1y9u",
    danger: "_bfhk1gly",
    information: "_bfhk19ip",
    discovery: "_bfhk6vm6",
    warning: "_bfhk1917",
    selected: "_bfhk15s3",
    disabled: "_bfhkl4ek"
};
const $56f1ec0b719310c0$var$styles = {
    InputCell: "_1ej8e4h9 _1vn8nqa1 _pxto1l7x",
    RowCell: "_1rjcze3t _179ria51 _bozgpxbi _1e0c1txw _4t3i1osq _4cvr1h6o _1vn8nqa1 _o5721q9c",
    defaultRowHeight: "_1tke66rk",
    compactRowHeight: "_1tke14no",
    overflowHiddenStyle: "_1reo15vq _18m915vq _1bto1l2s"
};
const $56f1ec0b719310c0$export$502da2b9cfd708e5 = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId, xcss: xcss, columnId: columnId, tableType: tableType = (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).input, style: style, cellBackground: cellBackground, rowSpacing: rowSpacing, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cda138ee9fda43ce$export$9cf5b401f969f5e3), {
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            background: !cellBackground ? 'inherit' : undefined,
            zIndex: `var(--col-${columnId}-zIndex)`,
            left: `var(--col-${columnId}-left)`,
            right: `var(--col-${columnId}-right)`,
            position: `var(--col-${columnId}-position)`,
            width: `var(--col-${columnId}-size)`,
            borderInlineEndWidth: `var(--col-${columnId}-resizing-border-width, var(--col-${columnId}-hover-border-width, var(--charlie-col-border-width, ${tableType === (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).input ? "var(--ds-border-width, 1px)" : '0px'})))`,
            borderInlineEndColor: `var(--col-${columnId}-resizing-border-color, var(--col-${columnId}-hover-border-color, ${"var(--ds-border, #0B120E24)"}))`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style
        },
        xcss: (0, $1Whri.cx)($56f1ec0b719310c0$var$styles.RowCell, tableType === (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).input && $56f1ec0b719310c0$var$styles.InputCell, cellBackground && $56f1ec0b719310c0$var$cellBackgroundStyles[cellBackground], $56f1ec0b719310c0$var$styles.overflowHiddenStyle, rowSpacing === 'compact' ? $56f1ec0b719310c0$var$styles.compactRowHeight : $56f1ec0b719310c0$var$styles.defaultRowHeight, xcss),
        ref: ref,
        ...props,
        children: children
    });
}));


const $ef8abf6d26ea5cb4$export$dfc6f2666f7e02b = (row, depthAddition, renderOptions)=>{
    const depthUnit = renderOptions?.expandableRow?.depthUnit ?? 8;
    const alignNonExpandable = renderOptions?.expandableRow?.alignNonExpandableRows ?? true;
    const basePadding = (row.depth + depthAddition) * depthUnit;
    const expandableWidth = 20;
    const rowPadding = !row.getCanExpand() && alignNonExpandable ? expandableWidth : 0;
    return `${basePadding + rowPadding}px`;
};





parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

// TODO: Using HipChat icons as the standard icon set is missing large
// versions of `chevron-up` and `chevron-down`, despite already including
// `chevron-left-large` and `chevron-right-large`...







var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");

const $684ee077f053fece$export$fcdb0af0473ee9e4 = /*#__PURE__*/ (0, $42omo.memo)(({ isExpanded: isExpanded })=>{
    switch(isExpanded){
        case false:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                spacing: "compact",
                label: "",
                color: "currentColor",
                size: "small"
            });
        case true:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                spacing: "compact",
                label: "",
                color: "currentColor",
                size: "small"
            });
    }
});


const $910d422e8a267989$export$4859b248303014ff = ({ row: row, interactionName: interactionName, analyticsContext: analyticsContext, labels: labels })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        spacing: "compact",
        testId: "expand-row-button",
        appearance: "subtle",
        interactionName: interactionName,
        analyticsContext: {
            componentName: 'charlieTableExpandRowButton',
            ...analyticsContext
        },
        "aria-expanded": row.getIsExpanded(),
        label: typeof labels?.expandRow === 'function' ? labels.expandRow(row) : labels?.expandRow,
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $684ee077f053fece$export$fcdb0af0473ee9e4), {
                isExpanded: row.getIsExpanded() ?? false,
                ...iconProps
            }),
        onClick: (e)=>{
            e.stopPropagation();
            row.toggleExpanded();
        }
    });


const $f8e4df047f955397$var$styles = {
    reservedColumnPadding: "_bozgu2gc",
    firstColumnBorder: "_191wia51",
    lastColumnBorder: "_t51zia51",
    SubRowButtonWrapperStyle: "_12l21b66",
    SubRowButtonFirstIndex: "_ahbqx0bf",
    RowCursorPointer: "_80omtlke",
    virtualRow: "_kqswstnw",
    columnResponsive: "_16jlkb7n"
};
function $f8e4df047f955397$export$3995a7f063dfe76d({ row: row, table: table, visibleCells: visibleCells, virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight, renderOptions: renderOptions, rowSpacing: rowSpacing, tableType: tableType, onRowClick: onRowClick, enableRowSelection: enableRowSelection, rowCellXcss: rowCellXcss, enableKeyboardNavigation: enableKeyboardNavigation, tableNavigationControllers: tableNavigationControllers, responsiveColumnSizing: responsiveColumnSizing, componentPropOverrides: componentPropOverrides, labels: labels, interactionName: interactionName, analyticsContext: analyticsContext, enableRowReorder: enableRowReorder, virtualRow: virtualRow, rowIndex: rowIndex, rowVirtualizer: rowVirtualizer }) {
    const shapeThemeRefresh = (0, $dh538.fg)('charlie-table-shape-refresh');
    const RowComponent = (0, $42omo.useMemo)(()=>{
        if (enableRowReorder) return /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $550ed92b14c5bb3f$export$d1e11c43191d6f47), {
                ...props,
                ref: ref
            }));
        return 0, $568c5bbbe63cf60f$export$b59bdbef9ce70de2;
    }, [
        enableRowReorder
    ]);
    return /*#__PURE__*/ (0, $42omo.createElement)(RowComponent, {
        row: row,
        index: virtualRow?.index ?? rowIndex,
        ...enableRowReorder && {
            enableRowReorder: enableRowReorder
        },
        "data-index": virtualRow?.index,
        key: row.id,
        ref: (node)=>rowVirtualizer ? rowVirtualizer.measureElement(node) : undefined,
        spacing: rowSpacing,
        onClick: (e)=>{
            // @ts-expect-error Prevent row click if a link was clicked
            if (e.target.closest('a')) return;
            onRowClick?.(row);
        },
        ...componentPropOverrides?.row && (0, $dh538.fg)('charly-table-with-row-table-handler') ? {
            ...componentPropOverrides.row({
                row: row
            })
        } : {},
        xcss: (0, $1Whri.cx)(onRowClick && $f8e4df047f955397$var$styles.RowCursorPointer, virtualRow && $f8e4df047f955397$var$styles.virtualRow),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...virtualRow ? {
                transform: `translateY(${virtualRow.start}px)`
            } : undefined
        },
        children: [
            virtualPaddingLeft ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                style: {
                    display: 'flex',
                    width: virtualPaddingLeft
                }
            }) : null,
            (virtualColumns ?? visibleCells).map((cellOrVirtualCell, index)=>{
                const cell = virtualColumns ? visibleCells[cellOrVirtualCell.index] : cellOrVirtualCell;
                const depthAddition = index === 0 ? 1 : 0;
                const cellBackground = renderOptions?.bodyCellBackground?.({
                    cell: cell,
                    state: table.getState()
                });
                const allColumns = table.getAllLeafColumns();
                const isFirstNonReserved = (0, $b2fd1883fd0c654d$export$355ef7276abf9248)(allColumns, index);
                const firstNonReservedColumnIndex = (0, $b2fd1883fd0c654d$export$75de7ce71826ef0b)(allColumns);
                const isResponsiveColumn = responsiveColumnSizing?.(cell.column);
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $56f1ec0b719310c0$export$502da2b9cfd708e5), {
                    isOverridingResponsiveColumnSizing: responsiveColumnSizing != null,
                    tableType: tableType,
                    columnId: cell.column.id,
                    rowSpacing: rowSpacing,
                    cellBackground: cellBackground,
                    xcss: (0, $1Whri.cx)((0, $b2fd1883fd0c654d$export$f8b7ab5a32f0b337)(cell.column.id) && $f8e4df047f955397$var$styles.reservedColumnPadding, isResponsiveColumn && $f8e4df047f955397$var$styles.columnResponsive, cell.row.getCanExpand() && isFirstNonReserved && $f8e4df047f955397$var$styles.reservedColumnPadding, !shapeThemeRefresh && index === 0 && $f8e4df047f955397$var$styles.firstColumnBorder, index === 0 && $f8e4df047f955397$var$styles.reservedColumnPadding, !shapeThemeRefresh && index === visibleCells.length - 1 && $f8e4df047f955397$var$styles.lastColumnBorder, rowCellXcss),
                    ...enableKeyboardNavigation && {
                        tabIndex: 0,
                        onKeyDown: tableNavigationControllers
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                        children: [
                            (row.depth > 0 && isFirstNonReserved || firstNonReservedColumnIndex === index && index === 0 && (!virtualPaddingLeft || isFirstNonReserved)) && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                                style: isFirstNonReserved && !row.getParentRow()?.getIsGrouped() && table.getCanSomeRowsExpand() ? {
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                                    paddingInlineStart: (0, $ef8abf6d26ea5cb4$export$dfc6f2666f7e02b)(row, depthAddition, renderOptions)
                                } : undefined,
                                xcss: $f8e4df047f955397$var$styles.reservedColumnPadding
                            }),
                            row.getCanExpand() && isFirstNonReserved && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: (0, $1Whri.cx)($f8e4df047f955397$var$styles.SubRowButtonWrapperStyle, !enableRowSelection && index === 0 && $f8e4df047f955397$var$styles.SubRowButtonFirstIndex),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $910d422e8a267989$export$4859b248303014ff), {
                                    row: row,
                                    interactionName: interactionName,
                                    analyticsContext: analyticsContext,
                                    labels: labels
                                })
                            }),
                            (0, $bVEgZ.flexRender)(cell.column.columnDef.cell, cell.getContext())
                        ]
                    })
                }, cell.id);
            }),
            virtualPaddingRight ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            /*#__PURE__*/ (0, $l998X.jsx)("td", {
                style: {
                    display: 'flex',
                    width: virtualPaddingRight
                }
            }) : null
        ]
    });
}


/* grouped-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


















const $881e8912aeef2ecb$var$SubRowExpandableStyle = null; /** Inline (left/right) borders for grouped row td when shape-theme-default is off. */ 
const $881e8912aeef2ecb$var$SubRowExpandableInlineBorderStyle = null; /** Block-end (bottom) border for grouped row td. */ 
const $881e8912aeef2ecb$var$SubRowExpandableBlockEndBorderStyle = null;
const $881e8912aeef2ecb$var$groupedRowBackgroundStyles = {
    success: "_bfhk1y9u",
    danger: "_bfhk1gly",
    information: "_bfhk19ip",
    discovery: "_bfhk6vm6",
    warning: "_bfhk1917",
    selected: "_bfhk15s3",
    disabled: "_bfhkl4ek"
};
const $881e8912aeef2ecb$var$styles = {
    subRowExpandableContainer: "_4t3i1osq",
    SubRowButtonWrapperStyle: "_12l21b66",
    RowCursorPointer: "_80omtlke",
    virtualRow: "_kqswstnw",
    SubRowExpandableStyleDefaultRowSize: "_1tke66rk",
    SubRowExpandableStyleCompactRowSize: "_1tke14no"
};
function $881e8912aeef2ecb$export$c8e88f20c1f65597({ row: row, table: table, renderOptions: renderOptions, renderChildComponent: renderChildComponent, rowSpacing: rowSpacing, onRowClick: onRowClick, groupedRowBackground: groupedRowBackground, virtualRow: virtualRow, rowIndex: rowIndex, rowVirtualizer: rowVirtualizer, componentPropOverrides: componentPropOverrides, labels: labels, interactionName: interactionName, analyticsContext: analyticsContext }) {
    const shapeThemeRefresh = (0, $dh538.fg)('charlie-table-shape-refresh');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $568c5bbbe63cf60f$export$b59bdbef9ce70de2), {
        "data-index": rowIndex,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...virtualRow ? {
                transform: `translateY(${virtualRow.start}px)`
            } : undefined
        },
        ref: (node)=>rowVirtualizer ? rowVirtualizer.measureElement(node) : undefined,
        spacing: rowSpacing,
        onClick: (e)=>{
            // @ts-expect-error Prevent row click if a link was clicked
            if (e.target.closest('a')) return;
            onRowClick?.(row);
        },
        ...componentPropOverrides?.row && (0, $dh538.fg)('charly-table-with-row-table-handler') ? {
            ...componentPropOverrides.row({
                row: row
            })
        } : {},
        xcss: (0, $1Whri.cx)(onRowClick && $881e8912aeef2ecb$var$styles.RowCursorPointer, virtualRow && $881e8912aeef2ecb$var$styles.virtualRow),
        children: /*#__PURE__*/ (0, $l998X.jsx)("td", {
            colSpan: row.getVisibleCells().length,
            className: (0, $gMc0m.default)([
                "_1rjcze3t _1ltvze3t _o5721q9c _1pbyb4wl _kqsw8hls _1bsb1osq _4t3i1osq",
                !shapeThemeRefresh && "_1h6d1l7x _tml8e4h9 _jxi8nqa1",
                "_1h6d1l7x _1doce4h9 _1il9nqa1",
                rowSpacing === 'compact' ? $881e8912aeef2ecb$var$styles.SubRowExpandableStyleCompactRowSize : $881e8912aeef2ecb$var$styles.SubRowExpandableStyleDefaultRowSize
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                alignItems: "center",
                xcss: (0, $1Whri.cx)($881e8912aeef2ecb$var$styles.subRowExpandableContainer, groupedRowBackground && $881e8912aeef2ecb$var$groupedRowBackgroundStyles[groupedRowBackground]),
                children: [
                    (renderChildComponent || renderOptions?.groupingRow) && row.getCanExpand() && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    ), {
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- this rule is specific for compiled
                            paddingInlineStart: (0, $ef8abf6d26ea5cb4$export$dfc6f2666f7e02b)(row, 1, renderOptions)
                        },
                        xcss: (0, $1Whri.cx)($881e8912aeef2ecb$var$styles.SubRowButtonWrapperStyle),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $910d422e8a267989$export$4859b248303014ff), {
                            row: row,
                            interactionName: interactionName,
                            analyticsContext: analyticsContext,
                            labels: labels
                        })
                    }),
                    row.original.overrideRender?.(row.original),
                    renderOptions?.groupingRow && renderOptions?.groupingRow(row.original, table.getState())
                ]
            })
        })
    });
}


const $6490284aedfa7015$var$styles = {
    tableBody: "_19121cl4"
};
const $6490284aedfa7015$export$ccee973a9f6f53e3 = ({ table: table, tableBodyRef: tableBodyRef, renderOptions: renderOptions, rowSpacing: rowSpacing, onRowClick: onRowClick, tableType: tableType, renderChildComponent: renderChildComponent, enableRowSelection: enableRowSelection, rowCellXcss: rowCellXcss, interactionName: interactionName, labels: labels, enableKeyboardNavigation: enableKeyboardNavigation, tableNavigationControllers: tableNavigationControllers, analyticsContext: analyticsContext, containerRef: containerRef, enableRowVirtualization: enableRowVirtualization, rowVirtualizerRef: rowVirtualizerRef, rowVirtualizerOptions: rowVirtualizerOptions, responsiveColumnSizing: responsiveColumnSizing, columnVirtualizer: columnVirtualizer, enableRowReorder: enableRowReorder = false, onDraggingRowEnd: _onDraggingRowEnd, componentPropOverrides: componentPropOverrides })=>{
    const rowVirtualizer = (0, $91935a6899fcbe2a$export$994a566b22e1207)({
        enableRowVirtualization: enableRowVirtualization,
        table: table,
        tableContainerRef: containerRef,
        rowSpacing: rowSpacing,
        rowVirtualizerRef: rowVirtualizerRef,
        rowVirtualizerOptions: rowVirtualizerOptions
    });
    const { rows: rowsFromModel } = table.getRowModel();
    const rows = rowVirtualizer ? rowVirtualizer.getVirtualItems() : rowsFromModel;
    const { virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight } = columnVirtualizer ?? {};
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ed7b2e09c17a13fe$export$7005b8a93a167348), {
        ref: tableBodyRef,
        xcss: $6490284aedfa7015$var$styles.tableBody,
        style: {
            height: rowVirtualizer ? `${rowVirtualizer.getTotalSize()}px` : undefined
        },
        children: rows ? rows.map((rowOrVirtualRow, index)=>{
            const virtualRow = rowVirtualizer ? rowOrVirtualRow : undefined;
            const row = rowVirtualizer ? rowsFromModel[rowOrVirtualRow.index] : rowOrVirtualRow;
            const visibleCells = row.getVisibleCells();
            const groupedRowBackground = row.getIsGrouped() ? renderOptions?.groupedRowBackground?.({
                rowData: row.original,
                state: table.getState()
            }) : undefined;
            const isGroupedOrOverride = row.original?.overrideRender || row.getIsGrouped() && renderOptions?.groupingRow;
            const sharedRowProps = {
                row: row,
                table: table,
                renderOptions: renderOptions,
                rowSpacing: rowSpacing,
                onRowClick: onRowClick,
                virtualRow: virtualRow,
                rowIndex: rowOrVirtualRow.index,
                rowVirtualizer: rowVirtualizer,
                componentPropOverrides: componentPropOverrides,
                labels: labels,
                interactionName: interactionName,
                analyticsContext: analyticsContext
            };
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                children: [
                    isGroupedOrOverride ? /*#__PURE__*/ (0, $l998X.jsx)((0, $881e8912aeef2ecb$export$c8e88f20c1f65597), {
                        ...sharedRowProps,
                        renderChildComponent: renderChildComponent,
                        groupedRowBackground: groupedRowBackground
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $f8e4df047f955397$export$3995a7f063dfe76d), {
                        ...sharedRowProps,
                        rowIndex: virtualRow?.index ?? index,
                        visibleCells: visibleCells,
                        virtualColumns: virtualColumns,
                        virtualPaddingLeft: virtualPaddingLeft,
                        virtualPaddingRight: virtualPaddingRight,
                        tableType: tableType,
                        enableRowSelection: enableRowSelection,
                        rowCellXcss: rowCellXcss,
                        enableKeyboardNavigation: enableKeyboardNavigation,
                        tableNavigationControllers: tableNavigationControllers,
                        responsiveColumnSizing: responsiveColumnSizing,
                        enableRowReorder: enableRowReorder
                    }),
                    row.getIsExpanded() && renderChildComponent && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                        children: renderChildComponent({
                            rowData: row,
                            tableState: table.getState()
                        })
                    })
                ]
            }, row.id);
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {})
    });
};
const $6490284aedfa7015$export$fe4b3545202378aa = (props)=>{
    const { table: { options: { data: data, state: { rowSelection: rowSelection, sorting: sorting, expanded: expanded, columnOrder: columnOrder, grouping: grouping, columnVisibility: columnVisibility } } }, containerRef: containerRef, rowSpacing: rowSpacing, renderOptions: renderOptions, componentPropOverrides: componentPropOverrides } = props;
    return (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $l998X.jsx)($6490284aedfa7015$export$ccee973a9f6f53e3, {
            ...props
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        rowSpacing,
        rowSelection,
        sorting,
        expanded,
        columnOrder,
        grouping,
        columnVisibility,
        data,
        containerRef,
        renderOptions,
        componentPropOverrides
    ]);
};


/* charlie-table-head-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


/* charlie-table-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 











/**
 * Utility functions for drag and drop operations in charlie-table
 */ const $a973082a70857008$export$6e195291211f6cda = ({ sourceColumnId: sourceColumnId, targetColumnId: targetColumnId, columnPinning: columnPinning })=>{
    if (sourceColumnId === targetColumnId) return true;
    const isSourceLeftPinned = columnPinning?.left?.includes(sourceColumnId);
    const isTargetLeftPinned = columnPinning?.left?.includes(targetColumnId);
    // Left-pinned columns can only be dropped on other left-pinned columns
    if (isSourceLeftPinned) return isTargetLeftPinned ?? false;
    // Unpinned columns cannot be dropped on left-pinned columns
    if (!isSourceLeftPinned) return !isTargetLeftPinned;
    return true;
};



/* more-actions-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $56M4r = parcelRequire("56M4r");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $6F6hl = parcelRequire("6F6hl");

const $930143e73475a4c9$export$4780246288fde46d = ({ movingColumnId: movingColumnId, targetDistance: targetDistance, columnOrder: columnOrder, columnVisibility: columnVisibility, columnPinning: columnPinning })=>{
    const isLeftPinned = columnPinning?.left?.includes(movingColumnId);
    // Handle left-pinned column reordering
    if (isLeftPinned && typeof targetDistance === 'number' && columnPinning?.left) {
        const leftPinned = [
            ...columnPinning.left
        ];
        const currentIndex = leftPinned.indexOf(movingColumnId);
        if (currentIndex < 0) return {
            columnOrder: columnOrder,
            columnPinning: columnPinning
        };
        const targetIndex = currentIndex + targetDistance;
        if (targetIndex < 0 || targetIndex >= leftPinned.length) return {
            columnOrder: columnOrder,
            columnPinning: columnPinning
        };
        // Reorder the pinned array
        const [removed] = leftPinned.splice(currentIndex, 1);
        leftPinned.splice(targetIndex, 0, removed);
        // Also reorder columnOrder to keep body columns aligned
        const newColumnOrder = [
            ...columnOrder
        ];
        const swapWithId = columnOrder[targetIndex];
        const orderSourceIndex = newColumnOrder.indexOf(movingColumnId);
        const orderTargetIndex = newColumnOrder.indexOf(swapWithId);
        if (orderSourceIndex >= 0 && orderTargetIndex >= 0) [newColumnOrder[orderSourceIndex], newColumnOrder[orderTargetIndex]] = [
            newColumnOrder[orderTargetIndex],
            newColumnOrder[orderSourceIndex]
        ];
        return {
            columnOrder: newColumnOrder,
            columnPinning: {
                ...columnPinning,
                left: leftPinned
            }
        };
    }
    /**
	 * Column order is affected by column visibility and column pinning.
	 * So if we're moving unpinned columns, we need to filter out the pinned columns and only use the visible columns.
	 */ const visibleColumnOrder = columnOrder.filter((id)=>columnVisibility?.[id] !== false && !columnPinning?.left?.includes(id) && !columnPinning?.right?.includes(id));
    const newColumnOrder = [
        ...columnOrder
    ];
    // Remove the moving column from its current position first
    const currentIndex = newColumnOrder.indexOf(movingColumnId);
    if (currentIndex !== -1) newColumnOrder.splice(currentIndex, 1);
    if (targetDistance === 'first') newColumnOrder.splice(0, 0, movingColumnId);
    else if (targetDistance === 'last') newColumnOrder.splice(newColumnOrder.length, 0, movingColumnId);
    else {
        const targetVisibleIndex = visibleColumnOrder.indexOf(movingColumnId) + targetDistance;
        const targetColumn = visibleColumnOrder[targetVisibleIndex];
        const targetIndex = columnOrder.indexOf(targetColumn);
        newColumnOrder.splice(targetIndex, 0, movingColumnId);
    }
    return {
        columnOrder: newColumnOrder,
        columnPinning: columnPinning
    };
};
const $930143e73475a4c9$export$6fdecee97cc9f200 = ({ column: column, tableState: tableState })=>{
    const columnOrder = tableState.columnOrder;
    const canMove = new Set();
    if (!columnOrder.includes(column.id)) return new Set();
    const isLeftPinned = tableState.columnPinning?.left?.includes(column.id);
    const leftPinnedColumns = tableState.columnPinning?.left || [];
    if (isLeftPinned) {
        const leftPinnedIndex = leftPinnedColumns.indexOf(column.id);
        // Can move left if not the leftmost left-pinned column
        if (leftPinnedIndex > 0) canMove.add('left');
        // Can move right if not the rightmost left-pinned column
        if (leftPinnedIndex < leftPinnedColumns.length - 1) canMove.add('right');
        return canMove;
    }
    if (!column.isPinned) {
        canMove.add('left');
        canMove.add('right');
        const visibleColumnOrder = columnOrder.filter((id)=>tableState.columnVisibility?.[id] !== false);
        const firstUnpinnedColumnIndex = visibleColumnOrder.findIndex((id)=>!leftPinnedColumns.includes(id) && !tableState.columnPinning?.right?.includes(id));
        const currentColumnIndex = visibleColumnOrder.indexOf(column.id);
        if (currentColumnIndex === firstUnpinnedColumnIndex) canMove.delete('left');
        const isLastColumn = column.isLastColumn('center') || columnOrder[columnOrder.length - 1] === column.id;
        if (isLastColumn) canMove.delete('right');
        return canMove;
    }
    return new Set();
};
const $930143e73475a4c9$export$97692e3d8582727e = ({ columnActions: columnActions, action: action })=>{
    const actionConfig = columnActions[action];
    const hasIcons = actionConfig && typeof actionConfig === 'object';
    return {
        iconBefore: hasIcons ? actionConfig.iconBefore : undefined,
        iconAfter: hasIcons ? actionConfig.iconAfter : undefined
    };
};


const $adc7b445c434f850$export$d1515a09b274390f = {
    pinToLeft: false,
    unpin: true,
    moveToFront: false,
    moveToBack: false,
    hiding: false,
    moveRight: true,
    moveLeft: true,
    sortAscending: true,
    sortDescending: true,
    clearSorting: true
};
const $adc7b445c434f850$export$6d97311821a4b62e = ({ column: column, closeMenu: closeMenu, labels: labels, tableState: tableState, tableActions: tableActions, allowedColumnMoves: allowedColumnMoves, columnActions: columnActions, interactionName: interactionName })=>{
    const canColumnSort = column.canSort;
    const isPinned = column.isPinned;
    const isLeftPinned = tableState.columnPinning?.left?.includes(column.id);
    const isRightPinned = tableState.columnPinning?.right?.includes(column.id);
    const showSortAscending = columnActions.sortAscending && canColumnSort;
    const showSortDescending = columnActions.sortDescending && canColumnSort;
    const showClearSorting = columnActions.clearSorting && canColumnSort && column.isSorted;
    const showMoveLeft = columnActions.moveLeft && allowedColumnMoves && allowedColumnMoves.has('left');
    const showMoveRight = columnActions.moveRight && allowedColumnMoves && allowedColumnMoves.has('right');
    const showMoveToFront = columnActions.moveToFront && !isPinned && allowedColumnMoves && allowedColumnMoves.has('left');
    const showMoveToBack = columnActions.moveToBack && !isPinned && allowedColumnMoves && allowedColumnMoves.has('right');
    const showPinToLeftActions = columnActions.pinToLeft && !isRightPinned;
    const showUnpinActions = columnActions.unpin && isPinned;
    const showPinningActions = showPinToLeftActions || showUnpinActions;
    const showHiding = columnActions.hiding && column.canHide;
    // TODO: Column order state defaults to [], so we need to do some checks to avoid weird behavior.
    const hasSortingActions = showSortAscending || showSortDescending || showClearSorting;
    const hasMoveActions = showMoveLeft || showMoveRight || showMoveToFront || showMoveToBack;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2SlZp.default), {
        children: [
            hasSortingActions && /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
                titleId: "sort-group-label",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                        id: "sort-group-label",
                        children: labels.sortGroup
                    }),
                    showSortAscending && /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ...(0, $930143e73475a4c9$export$97692e3d8582727e)({
                            columnActions: columnActions,
                            action: 'sortAscending'
                        }),
                        interactionName: `${interactionName}-sort-ascending`,
                        onClick: ()=>{
                            tableActions.toggleSorting(false);
                            closeMenu?.();
                        },
                        children: labels.sortAscending
                    }),
                    showSortDescending && /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ...(0, $930143e73475a4c9$export$97692e3d8582727e)({
                            columnActions: columnActions,
                            action: 'sortDescending'
                        }),
                        interactionName: `${interactionName}-sort-descending`,
                        onClick: ()=>{
                            tableActions.toggleSorting(true);
                            closeMenu?.();
                        },
                        children: labels.sortDescending
                    }),
                    showClearSorting && /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ...(0, $930143e73475a4c9$export$97692e3d8582727e)({
                            columnActions: columnActions,
                            action: 'clearSorting'
                        }),
                        interactionName: `${interactionName}-clear-sorting`,
                        onClick: ()=>{
                            tableActions.clearSorting();
                            closeMenu?.();
                        },
                        children: labels.clearSorting
                    })
                ]
            }),
            hasMoveActions && /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
                titleId: "move-column-group-label",
                hasSeparator: !!hasSortingActions,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                        id: "move-column-group-label",
                        children: labels.moveColumnGroup
                    }),
                    showMoveLeft && /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ...(0, $930143e73475a4c9$export$97692e3d8582727e)({
                            columnActions: columnActions,
                            action: 'moveLeft'
                        }),
                        interactionName: `${interactionName}-move-column-left`,
                        onClick: ()=>{
                            const result = (0, $930143e73475a4c9$export$4780246288fde46d)({
                                movingColumnId: column.id,
                                targetDistance: -1,
                                columnOrder: tableState.columnOrder,
                                columnVisibility: tableState.columnVisibility,
                                columnPinning: tableState.columnPinning
                            });
                            tableActions.setColumnOrder(result.columnOrder);
                            if (result.columnPinning) tableActions.setColumnPinning(result.columnPinning);
                            closeMenu?.();
                        },
                        children: labels.moveColumnLeft
                    }),
                    showMoveRight && /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ...(0, $930143e73475a4c9$export$97692e3d8582727e)({
                            columnActions: columnActions,
                            action: 'moveRight'
                        }),
                        interactionName: `${interactionName}-move-column-right`,
                        onClick: ()=>{
                            const result = (0, $930143e73475a4c9$export$4780246288fde46d)({
                                movingColumnId: column.id,
                                targetDistance: 1,
                                columnOrder: tableState.columnOrder,
                                columnVisibility: tableState.columnVisibility,
                                columnPinning: tableState.columnPinning
                            });
                            tableActions.setColumnOrder(result.columnOrder);
                            if (result.columnPinning) tableActions.setColumnPinning(result.columnPinning);
                            closeMenu?.();
                        },
                        children: labels.moveColumnRight
                    }),
                    showMoveToFront && /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ...(0, $930143e73475a4c9$export$97692e3d8582727e)({
                            columnActions: columnActions,
                            action: 'moveToFront'
                        }),
                        interactionName: `${interactionName}-move-column-first`,
                        onClick: ()=>{
                            const result = (0, $930143e73475a4c9$export$4780246288fde46d)({
                                movingColumnId: column.id,
                                targetDistance: 'first',
                                columnOrder: tableState.columnOrder,
                                columnVisibility: tableState.columnVisibility,
                                columnPinning: tableState.columnPinning
                            });
                            tableActions.setColumnOrder(result.columnOrder);
                            if (result.columnPinning) tableActions.setColumnPinning(result.columnPinning);
                            closeMenu?.();
                        },
                        children: labels.moveColumnFirst
                    }),
                    showMoveToBack && /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ...(0, $930143e73475a4c9$export$97692e3d8582727e)({
                            columnActions: columnActions,
                            action: 'moveToBack'
                        }),
                        interactionName: `${interactionName}-move-column-last`,
                        onClick: ()=>{
                            const result = (0, $930143e73475a4c9$export$4780246288fde46d)({
                                movingColumnId: column.id,
                                targetDistance: 'last',
                                columnOrder: tableState.columnOrder,
                                columnVisibility: tableState.columnVisibility,
                                columnPinning: tableState.columnPinning
                            });
                            tableActions.setColumnOrder(result.columnOrder);
                            if (result.columnPinning) tableActions.setColumnPinning(result.columnPinning);
                            closeMenu?.();
                        },
                        children: labels.moveColumnLast
                    })
                ]
            }),
            (showPinningActions || showHiding) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
                titleId: "column-visibility-group-label",
                hasSeparator: !!(hasSortingActions || hasMoveActions),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                        id: "column-visibility-group-label",
                        children: labels.columnVisibilityGroup
                    }),
                    showPinningActions && isLeftPinned && /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ...(0, $930143e73475a4c9$export$97692e3d8582727e)({
                            columnActions: columnActions,
                            action: 'unpin'
                        }),
                        interactionName: `${interactionName}-unpin-column`,
                        onClick: ()=>{
                            tableActions.setColumnPinning({
                                ...tableState.columnPinning,
                                left: tableState.columnPinning?.left?.filter((columnId)=>columnId !== column.id)
                            });
                            closeMenu?.();
                        },
                        children: labels.unpinColumn
                    }),
                    showPinToLeftActions && !isLeftPinned && /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ...(0, $930143e73475a4c9$export$97692e3d8582727e)({
                            columnActions: columnActions,
                            action: 'pinToLeft'
                        }),
                        interactionName: `${interactionName}-pin-column`,
                        onClick: ()=>{
                            tableActions.setColumnPinning({
                                ...tableState.columnPinning,
                                left: [
                                    ...tableState.columnPinning?.left || [],
                                    column.id
                                ]
                            });
                            closeMenu?.();
                        },
                        children: labels.pinColumn
                    }),
                    showHiding && /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        ...(0, $930143e73475a4c9$export$97692e3d8582727e)({
                            columnActions: columnActions,
                            action: 'hiding'
                        }),
                        interactionName: `${interactionName}-hide-column`,
                        onClick: ()=>{
                            tableActions.setColumnVisibility({
                                ...tableState.columnVisibility,
                                [column.id]: false
                            });
                            closeMenu?.();
                        },
                        children: labels.hideColumn
                    })
                ]
            })
        ]
    }, "sort-actions");
};



/* head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















const $696853efb3fca03d$export$2b39a3648955dd09 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9866f5f0abd9e328$export$41ad0bbfa4755cac), {
        as: "th",
        ref: ref,
        ...props
    });
});



const $b824b9b815d7a642$var$headCellStyles = {
    HeadCell: "_1h6d1l7x _18zru2gc _1pby1kze _kqsw1if8 _o5721q9c _s7n4nkob _syaz1rpy _y3gn1e5h _154ize3t _1e0c1txw _4cvr1h6o _1vn8nqa1",
    InventoryHead: "_mqm2ia51 _179r1uh4 _4t3ickbl _bfhkvuon",
    InventoryHeadShapeTheme: "_179r1uh4 _4t3ickbl _bfhkvuon",
    InputHeadStyle: "_mqm2ia51 _179ria51 _bfhkhfxm _1vn8nqa1 _1ej8e4h9",
    InputHeadStyleShapeTheme: "_179ria51 _bfhkhfxm _1vn8nqa1 _1ej8e4h9"
};
const $b824b9b815d7a642$var$pinnedColumnLeftStyle = null;
const $b824b9b815d7a642$var$pinnedColumnRightStyle = null;
const $b824b9b815d7a642$export$4e8024263ace498b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, align: align, testId: testId, backgroundColor: backgroundColor, xcss: xcss, scope: scope = 'col', tableType: tableType = (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).input, isPinningEdge: isPinningEdge, ...props }, ref)=>{
    const shapeThemeRefresh = (0, $dh538.fg)('charlie-table-shape-refresh');
    const inputDefault = tableType === (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).input && !shapeThemeRefresh;
    const inputWithShapeTheme = tableType === (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).input && shapeThemeRefresh;
    const inventoryDefault = tableType === (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).inventory && !shapeThemeRefresh;
    const inventoryWithShapeTheme = tableType === (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).inventory && shapeThemeRefresh;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $696853efb3fca03d$export$2b39a3648955dd09), {
        ...props,
        scope: scope,
        align: align,
        testId: testId,
        ref: ref,
        xcss: (0, $1Whri.cx)($b824b9b815d7a642$var$headCellStyles.HeadCell, inventoryWithShapeTheme && $b824b9b815d7a642$var$headCellStyles.InventoryHeadShapeTheme, inventoryDefault && $b824b9b815d7a642$var$headCellStyles.InventoryHead, inputWithShapeTheme && $b824b9b815d7a642$var$headCellStyles.InputHeadStyleShapeTheme, inputDefault && $b824b9b815d7a642$var$headCellStyles.InputHeadStyle, xcss),
        backgroundColor: tableType === (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).inventory ? 'elevation.surface' : tableType === (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).input ? 'elevation.surface.sunken' : backgroundColor,
        children: [
            children,
            isPinningEdge && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    isPinningEdge === 'left' && "_kqswstnw _154ize3t _1xi2ze3t _16r27p75 _aetrb3bt _18postnw _32rx196n _15l2ze3t _1qdg1j7e _z0aii2wt",
                    isPinningEdge === 'right' && "_kqswstnw _154ize3t _1ltvze3t _1s6k7z6m _1kt9b3bt _1cs8stnw _qnec196n _1aukidpf _kfgt1j7e _1mp4i2wt"
                ])
            })
        ]
    });
});


/* header-cell-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $8aNCk = parcelRequire("8aNCk");






var $u9agA = parcelRequire("u9agA");

/* header-more-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $lGgRw = parcelRequire("lGgRw");


/* more-actions-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $9VJDA = parcelRequire("9VJDA");




const $fdc060ff146edf6f$var$styles = {
    base: "_v5641ae1",
    hidden: "_1reo15vq _18m915vq _p12fidpf _tzy4idpf",
    visible: "_1reoewfl _18m9ewfl _p12fzwfg _tzy4kb7n",
    animateSlideIn: "_v5642o16"
};
const $fdc060ff146edf6f$export$295351a5a2c5d9fb = ({ popupTriggerProps: popupTriggerProps, showMoreActionsButton: showMoreActionsButton, onToggleMoreActions: onToggleMoreActions, interactionName: interactionName, analyticsContext: analyticsContext, isMoreActionsOpened: isMoreActionsOpened, moreActionsLabel: moreActionsLabel, onFocus: onFocus, onBlur: onBlur, isSortingActive: isSortingActive })=>{
    const triggerContent = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($fdc060ff146edf6f$var$styles.base, showMoreActionsButton ? $fdc060ff146edf6f$var$styles.visible : $fdc060ff146edf6f$var$styles.hidden, isSortingActive && $fdc060ff146edf6f$var$styles.animateSlideIn),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                ...popupTriggerProps,
                spacing: "compact",
                appearance: "subtle",
                onClick: onToggleMoreActions,
                interactionName: interactionName,
                analyticsContext: {
                    componentName: 'charlieTableMoreActionsColumnButton',
                    ...analyticsContext
                },
                isSelected: isMoreActionsOpened,
                isTooltipDisabled: false,
                label: moreActionsLabel,
                onFocus: onFocus,
                onBlur: onBlur,
                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                        children: showMoreActionsButton && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                            ...iconProps,
                            color: "currentColor",
                            size: "small"
                        })
                    })
            })
        }), [
        showMoreActionsButton,
        isSortingActive,
        popupTriggerProps,
        onToggleMoreActions,
        interactionName,
        analyticsContext,
        isMoreActionsOpened,
        moreActionsLabel,
        onFocus,
        onBlur
    ]);
    return triggerContent;
};


const $9f229dfed2a0e5d6$export$4ccf88d05914ab3a = ({ columnMetadata: columnMetadata, charlieTableState: charlieTableState, tableActions: tableActions, labels: labels, allowedColumnActionMoves: allowedColumnActionMoves, columnActions: columnActions, interactionName: interactionName, analyticsContext: analyticsContext, showMoreActionsButton: showMoreActionsButton, isMoreActionsOpened: isMoreActionsOpened, onToggleMoreActions: onToggleMoreActions, onMoreActionsClose: onMoreActionsClose, moreActionsLabel: moreActionsLabel, onMoreActionsFocusChange: onMoreActionsFocusChange, isSortingActive: isSortingActive })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $adc7b445c434f850$export$6d97311821a4b62e), {
                column: columnMetadata,
                tableState: charlieTableState.getState(),
                tableActions: tableActions,
                closeMenu: onMoreActionsClose,
                labels: labels,
                allowedColumnMoves: allowedColumnActionMoves,
                columnActions: columnActions,
                interactionName: interactionName
            }),
        zIndex: 510,
        onClose: onMoreActionsClose,
        isOpen: isMoreActionsOpened,
        placement: "bottom-start",
        trigger: (popupTriggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fdc060ff146edf6f$export$295351a5a2c5d9fb), {
                popupTriggerProps: popupTriggerProps,
                showMoreActionsButton: showMoreActionsButton,
                onToggleMoreActions: onToggleMoreActions,
                interactionName: interactionName,
                analyticsContext: analyticsContext,
                isMoreActionsOpened: isMoreActionsOpened,
                moreActionsLabel: moreActionsLabel,
                onFocus: ()=>onMoreActionsFocusChange(true),
                onBlur: ()=>onMoreActionsFocusChange(false),
                isSortingActive: isSortingActive
            })
    });


/* header-sort-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 








/* sort-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $22Iw9 = parcelRequire("22Iw9");


var $euUgw = parcelRequire("euUgw");

const $d651e825a5ef535d$var$styles = null;
const $d651e825a5ef535d$var$SortableIconClassName = 'sortable-icon'; /**
                                                * __SortIcon__
                                                *
                                                * SortIcon is used to display the sort state in our SortableColumn.
                                                */ 
const $d651e825a5ef535d$export$72820c4f313d7b94 = /*#__PURE__*/ (0, $42omo.memo)(({ sortDirection: sortDirection, isCurrentSort: isCurrentSort })=>{
    const primaryColor = isCurrentSort ? "var(--ds-icon-brand, #1868DB)" : "var(--ds-icon, #292A2E)";
    const showSortUp = sortDirection === 'asc';
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_v5641w7c _1e0c1txw _1wpz1h6o _tzy4kb7n",
            $d651e825a5ef535d$var$SortableIconClassName
        ]),
        children: showSortUp ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
            label: "",
            color: primaryColor,
            spacing: "compact",
            size: "small"
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
            label: "",
            color: primaryColor,
            spacing: "compact",
            size: "small"
        })
    });
});


const $e89f56c111adc8e2$export$6c9739352aed12ff = ({ charlieTableColumn: charlieTableColumn, showSortButton: showSortButton, sortDirection: sortDirection, sortLabel: sortLabel, onSortButtonFocusChange: onSortButtonFocusChange, onToggleSort: onToggleSort, interactionName: interactionName, analyticsContext: analyticsContext })=>{
    const nextSortDirection = charlieTableColumn.column.getNextSortingOrder();
    const displaySortDirection = sortDirection || nextSortDirection || 'asc';
    const label = sortLabel != null ? typeof sortLabel === 'function' ? sortLabel(charlieTableColumn) : sortLabel : '';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        testId: `${charlieTableColumn.id}-sort-button`,
        spacing: "compact",
        appearance: "subtle",
        onClick: onToggleSort,
        interactionName: interactionName,
        analyticsContext: {
            componentName: 'charlieTableSortColumnButton',
            ...analyticsContext
        },
        isTooltipDisabled: !label,
        label: label,
        onFocus: ()=>onSortButtonFocusChange(true),
        onBlur: ()=>onSortButtonFocusChange(false),
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                children: (showSortButton || sortDirection) && /*#__PURE__*/ (0, $l998X.jsx)((0, $d651e825a5ef535d$export$72820c4f313d7b94), {
                    ...iconProps,
                    sortDirection: displaySortDirection,
                    isCurrentSort: Boolean(sortDirection)
                })
            })
    });
};


const $7446f1a1d137d808$var$styles = {
    reorderingStyle: "_4cvr1h6o _1bsb1osq",
    notReorderingPaddingStyle: "_bozgu2gc _4cvr1h6o _1bsb1osq",
    overflowInlineStyle: "_1reo15vq _18m915vq _4cvr1h6o _1bsb1osq",
    buttonFont: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _syaz1rpy _y3gn1e5h _k48pwu06",
    buttonFontCurrentSort: "_syaz1oa5",
    dragHandlerIconContainerStyle: "_4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1j6v",
    hideColumnActions: "_1reo15vq _18m915vq _1bsbidpf _tzy4idpf",
    showColumnActions: "_1reoewfl _18m9ewfl _v5641p41 _tzy4kb7n"
};
const $7446f1a1d137d808$export$8fcee14b42aad10f = ({ charlieTableColumn: charlieTableColumn, charlieTableState: charlieTableState, labels: labels, columnMetadata: columnMetadata, tableActions: tableActions, allowedColumnActionMoves: allowedColumnActionMoves, mergedColumnActions: mergedColumnActions, canColumnReorderDnd: canColumnReorderDnd, canColumnSort: canColumnSort, isMoreActionsEnabled: isMoreActionsEnabled, showDragHandler: showDragHandler, showSortButton: showSortButton, sortDirection: sortDirection, showColumnActions: showColumnActions, showMoreActionsButton: showMoreActionsButton, isMoreActionsOpened: isMoreActionsOpened, onToggleMoreActions: onToggleMoreActions, onMoreActionsClose: onMoreActionsClose, onSortButtonFocusChange: onSortButtonFocusChange, onMoreActionsFocusChange: onMoreActionsFocusChange, interactionName: interactionName, analyticsContext: analyticsContext, tooltipProps: tooltipProps })=>{
    const moreActionsLabel = typeof labels.moreActions === 'function' ? labels.moreActions(charlieTableColumn) : labels.moreActions;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        spread: canColumnSort || isMoreActionsEnabled ? 'space-between' : undefined,
        xcss: canColumnReorderDnd ? $7446f1a1d137d808$var$styles.reorderingStyle : $7446f1a1d137d808$var$styles.notReorderingPaddingStyle,
        ...tooltipProps,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $7446f1a1d137d808$var$styles.overflowInlineStyle,
                children: [
                    canColumnReorderDnd && /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        xcss: $7446f1a1d137d808$var$styles.dragHandlerIconContainerStyle,
                        children: showDragHandler && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8aNCk))), {
                            label: "Drag list item",
                            color: "var(--ds-icon, #292A2E)",
                            size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($7446f1a1d137d808$var$styles.buttonFont, sortDirection && $7446f1a1d137d808$var$styles.buttonFontCurrentSort),
                        children: (0, $bVEgZ.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext())
                    })
                ]
            }),
            (canColumnSort || isMoreActionsEnabled) && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: showColumnActions ? $7446f1a1d137d808$var$styles.showColumnActions : $7446f1a1d137d808$var$styles.hideColumnActions,
                children: [
                    canColumnSort && /*#__PURE__*/ (0, $l998X.jsx)((0, $e89f56c111adc8e2$export$6c9739352aed12ff), {
                        charlieTableColumn: charlieTableColumn,
                        showSortButton: !!showSortButton,
                        sortDirection: sortDirection,
                        sortLabel: labels.sortLabel,
                        onSortButtonFocusChange: onSortButtonFocusChange,
                        onToggleSort: ()=>charlieTableColumn.column.toggleSorting(),
                        interactionName: interactionName,
                        analyticsContext: analyticsContext
                    }),
                    isMoreActionsEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $9f229dfed2a0e5d6$export$4ccf88d05914ab3a), {
                        columnMetadata: columnMetadata,
                        charlieTableState: charlieTableState,
                        tableActions: tableActions,
                        labels: labels,
                        allowedColumnActionMoves: allowedColumnActionMoves,
                        columnActions: mergedColumnActions,
                        interactionName: interactionName,
                        analyticsContext: analyticsContext,
                        showMoreActionsButton: !!showMoreActionsButton,
                        isMoreActionsOpened: !!isMoreActionsOpened,
                        onToggleMoreActions: onToggleMoreActions,
                        onMoreActionsClose: onMoreActionsClose,
                        moreActionsLabel: moreActionsLabel,
                        onMoreActionsFocusChange: onMoreActionsFocusChange,
                        isSortingActive: !!sortDirection
                    })
                ]
            })
        ]
    });
};


/* header-tooltip.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");

const $ccbb2f31a2ffbcec$var$styles = {
    headerDescription: "_2rkolb4i _vchhusvi _c71ldgin _p12f1mjv _16qs130s _syazi7uo _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66"
};
const $ccbb2f31a2ffbcec$export$dd48657eabf73f1a = ({ charlieTableColumn: charlieTableColumn, children: children })=>{
    const description = charlieTableColumn.column.columnDef.meta?.description;
    const hasDescription = Boolean(description);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        component: /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
            const { children: tooltipChildren, ...rest } = props;
            if (ref == null) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
                ...rest,
                ref: ref,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    backgroundColor: "elevation.surface.overlay",
                    xcss: $ccbb2f31a2ffbcec$var$styles.headerDescription,
                    children: tooltipChildren
                })
            });
        }),
        content: hasDescription && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("b", {
                    children: (0, $bVEgZ.flexRender)(charlieTableColumn.column.columnDef.header, charlieTableColumn.getContext())
                }),
                description
            ]
        }),
        position: "bottom",
        children: children
    });
};


const $b427ec7ae9ac75dc$export$31b5f58e3936ace6 = (e, isHoveringCell, setHoveringCell)=>{
    const headerElement = e.currentTarget;
    const headerRect = headerElement.getBoundingClientRect();
    const mouseY = e.clientY;
    // Mouse is in extended area if it's beyond the cell bounds
    const isInExtendedArea = mouseY < headerRect.top || mouseY > headerRect.bottom;
    const shouldShowHover = !isInExtendedArea;
    // Only update state if it needs to change
    if (shouldShowHover !== isHoveringCell) setHoveringCell(shouldShowHover);
};


/* pragmatic-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $5X6QO = parcelRequire("5X6QO");


var $gZctg = parcelRequire("gZctg");
















var $51lK8 = parcelRequire("51lK8");







const $697463b37f166953$export$435719ededc46a43 = ({ wrapperRef: wrapperRef, enableColumnReorder: enableColumnReorder, enableRowReorder: enableRowReorder, leftPinnedColumnsWidth: leftPinnedColumnsWidth = 0, rightPinnedColumnsWidth: rightPinnedColumnsWidth = 0 })=>{
    const hasLeftPinnedColumns = leftPinnedColumnsWidth > 0;
    const hasRightPinnedColumns = rightPinnedColumnsWidth > 0;
    const hasPinnedColumns = hasLeftPinnedColumns || hasRightPinnedColumns;
    (0, $42omo.useEffect)(()=>{
        if (!enableColumnReorder && !enableRowReorder) return;
        const wrapper = wrapperRef.current;
        if (!wrapper) return;
        const canScroll = ({ source: source })=>{
            return source.data.type === 'item-column' || source.data.type === 'item-row';
        };
        // standard autoscroll handles scrolling when cursor reaches the actual container edge
        const standardAutoScroll = (0, $51lK8.autoScrollForElements)({
            element: wrapper,
            canScroll: canScroll
        });
        if (!hasPinnedColumns || !enableColumnReorder) return standardAutoScroll;
        let rafId = null;
        let scrollDirection = null;
        const scroll = ()=>{
            if (scrollDirection) {
                // 15px per frame is the standard autoscroll speed
                wrapper.scrollBy({
                    left: scrollDirection === 'left' ? -15 : 15
                });
                rafId = requestAnimationFrame(scroll);
            }
        };
        const startScrolling = (direction)=>{
            if (scrollDirection === direction) return;
            stopScrolling();
            scrollDirection = direction;
            rafId = requestAnimationFrame(scroll);
        };
        const stopScrolling = ()=>{
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
            scrollDirection = null;
        };
        const pinnedColumnScrollMonitor = (0, $4T4vf.monitorForElements)({
            canMonitor: ({ source: source })=>source.data.type === 'item-column',
            onDrag: ({ location: location })=>{
                const { clientX: clientX, clientY: clientY } = location.current.input;
                const wrapperRect = wrapper.getBoundingClientRect();
                // check if cursor is within the wrapper
                if (clientY < wrapperRect.top || clientY > wrapperRect.bottom) {
                    stopScrolling();
                    return;
                }
                // check if cursor is near the right edge of left-pinned columns (scroll left)
                if (hasLeftPinnedColumns && wrapper.scrollLeft > 0) {
                    const hitboxStart = wrapperRect.left + leftPinnedColumnsWidth;
                    const hitboxEnd = hitboxStart + 60;
                    if (clientX >= hitboxStart && clientX <= hitboxEnd) {
                        startScrolling('left');
                        return;
                    }
                }
                // check if cursor is near the left edge of right-pinned columns (scroll right)
                if (hasRightPinnedColumns) {
                    const canScrollRight = wrapper.scrollLeft + wrapper.clientWidth < wrapper.scrollWidth;
                    if (canScrollRight) {
                        const hitboxEnd = wrapperRect.right - rightPinnedColumnsWidth;
                        const hitboxStart = hitboxEnd - 60;
                        if (clientX >= hitboxStart && clientX <= hitboxEnd) {
                            startScrolling('right');
                            return;
                        }
                    }
                }
                stopScrolling();
            },
            onDrop: stopScrolling
        });
        return (0, $bSjaC.combine)(standardAutoScroll, pinnedColumnScrollMonitor, stopScrolling);
    }, [
        enableColumnReorder,
        enableRowReorder,
        wrapperRef,
        hasPinnedColumns,
        hasLeftPinnedColumns,
        hasRightPinnedColumns,
        leftPinnedColumnsWidth,
        rightPinnedColumnsWidth
    ]);
};













var $7XdU2 = parcelRequire("7XdU2");


var $d4P2q = parcelRequire("d4P2q");

const $0a2c9dd5fcc37f12$export$c7cb8d6a95937614 = ({ source: source, target: target, charlieTableState: charlieTableState, columnOrder: columnOrder })=>{
    const pinning = charlieTableState.getState().columnPinning;
    const sourceColumnId = source.data.id;
    const targetColumnId = target.data.id;
    const isSourceLeftPinned = pinning?.left?.includes(sourceColumnId);
    const isTargetLeftPinned = pinning?.left?.includes(targetColumnId);
    // Handle left-pinned column reordering
    if (isSourceLeftPinned && isTargetLeftPinned && pinning?.left) {
        const leftPinned = [
            ...pinning.left
        ];
        const sourceIndex = leftPinned.indexOf(sourceColumnId);
        const targetIndex = leftPinned.indexOf(targetColumnId);
        if (sourceIndex < 0 || targetIndex < 0) return;
        const closestEdgeOfTarget = (0, $2WHHL.extractClosestEdge)(target.data);
        let finishIndex = targetIndex;
        if (closestEdgeOfTarget === 'right') finishIndex = targetIndex + 1;
        if (sourceIndex < finishIndex) finishIndex--;
        if (finishIndex === sourceIndex) return;
        const [removed] = leftPinned.splice(sourceIndex, 1);
        leftPinned.splice(finishIndex, 0, removed);
        charlieTableState.setColumnPinning({
            ...pinning,
            left: leftPinned
        });
        // Update columnOrder to ensure body is reordered, not just header
        const currentOrder = [
            ...columnOrder
        ];
        const orderSourceIndex = currentOrder.indexOf(sourceColumnId);
        const orderTargetIndex = currentOrder.indexOf(targetColumnId);
        if (orderSourceIndex >= 0 && orderTargetIndex >= 0) {
            currentOrder.splice(orderSourceIndex, 1);
            const newTargetIndex = currentOrder.indexOf(targetColumnId);
            const insertIndex = closestEdgeOfTarget === 'right' ? newTargetIndex + 1 : newTargetIndex;
            currentOrder.splice(insertIndex, 0, sourceColumnId);
            charlieTableState.setColumnOrderWithContext(currentOrder, {
                trigger: 'drag'
            });
        }
        return;
    }
    // Handle unpinned column reordering
    const columnIds = columnOrder;
    const startIndex = columnIds.findIndex((item)=>item === source.data.id);
    if (startIndex < 0) return;
    const indexOfTarget = columnIds.findIndex((item)=>item === target.data.id);
    if (indexOfTarget < 0) return;
    const closestEdgeOfTarget = (0, $2WHHL.extractClosestEdge)(target.data);
    const finishIndex = (0, $7XdU2.getReorderDestinationIndex)({
        startIndex: startIndex,
        closestEdgeOfTarget: closestEdgeOfTarget,
        indexOfTarget: indexOfTarget,
        axis: 'horizontal'
    });
    if (finishIndex === startIndex) return;
    const newOrder = (0, $d4P2q.reorder)({
        list: columnIds,
        startIndex: startIndex,
        finishIndex: finishIndex
    });
    charlieTableState.setColumnOrderWithContext(newOrder, {
        trigger: 'drag'
    });
};








const $2ad52af7f2ac5c85$export$568b591eadb2e59a = ({ source: source, target: target, charlieTableState: charlieTableState, onDraggingRowEnd: onDraggingRowEnd })=>{
    if (!onDraggingRowEnd) return;
    const startIndex = source.data.index;
    const targetIndex = target.data.index;
    if (typeof startIndex !== 'number' || typeof targetIndex !== 'number') return;
    if (startIndex === targetIndex) return;
    const closestEdgeOfTarget = (0, $2WHHL.extractClosestEdge)(target.data);
    const finishIndex = (0, $7XdU2.getReorderDestinationIndex)({
        startIndex: startIndex,
        closestEdgeOfTarget: closestEdgeOfTarget,
        indexOfTarget: targetIndex,
        axis: 'vertical'
    });
    if (finishIndex === startIndex) return;
    onDraggingRowEnd({
        table: charlieTableState,
        draggingRow: source.data.row,
        destinationRow: target.data.row
    });
};


const $40962bbf2bd8295b$export$602210aed46cbcc4 = ({ tableRef: tableRef, charlieTableState: charlieTableState, enableColumnReorder: enableColumnReorder, enableRowReorder: enableRowReorder, onDraggingRowEnd: onDraggingRowEnd })=>{
    const columnOrderState = charlieTableState.getState?.().columnOrder;
    const hasOrder = !!columnOrderState?.length;
    const columnOrder = (0, $42omo.useMemo)(()=>{
        if (hasOrder) return columnOrderState;
        return charlieTableState.getAllLeafColumns?.().map((c)=>c.id) ?? [];
    }, [
        columnOrderState,
        hasOrder,
        charlieTableState
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!enableColumnReorder && !enableRowReorder) return;
        return (0, $4T4vf.monitorForElements)({
            canMonitor: ({ source: source })=>(source.data.type === 'item-column' || source.data.type === 'item-row') && (0, $45acf452ad2feb70$export$4ef518c7050e21b)(source.element, tableRef.current),
            onDrop ({ location: location, source: source }) {
                const target = location.current.dropTargets[0];
                if (!target) return;
                // Handle column reordering
                if (source.data.type === 'item-column' && enableColumnReorder) {
                    (0, $0a2c9dd5fcc37f12$export$c7cb8d6a95937614)({
                        source: source,
                        target: target,
                        charlieTableState: charlieTableState,
                        columnOrder: columnOrder
                    });
                    return;
                }
                // Handle row reordering
                if (source.data.type === 'item-row' && enableRowReorder) (0, $2ad52af7f2ac5c85$export$568b591eadb2e59a)({
                    source: source,
                    target: target,
                    charlieTableState: charlieTableState,
                    onDraggingRowEnd: onDraggingRowEnd
                });
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        charlieTableState,
        columnOrder,
        enableRowReorder,
        enableColumnReorder,
        onDraggingRowEnd
    ]);
};






const $ce8210834985e75f$export$fa1aba135c313d2f = ({ tableRef: tableRef })=>{
    (0, $42omo.useEffect)(()=>{
        const table = tableRef.current;
        if (!table) return;
        const resizeObserver = new ResizeObserver((entries)=>{
            for (const { contentBoxSize: contentBoxSize } of entries){
                if (!contentBoxSize) return;
                const [{ blockSize: blockSize }] = contentBoxSize;
                // subtracting 1 to prevent an overflow from happening
                table.style.setProperty((0, $90747fbed8ccb7bc$export$4c4d2d5ba926bbe5), `${blockSize - 1}px`);
            }
        });
        resizeObserver.observe(table);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        tableRef
    ]);
};






var $fFa3V = parcelRequire("fFa3V");


const $a053f3fad785a567$export$4b14221c5f4ccf02 = ({ tableRef: tableRef, wrapperRef: wrapperRef, tbodyRef: tbodyRef, charlieTableState: charlieTableState })=>{
    const onScroll = (0, $42omo.useCallback)(()=>{
        const table = tableRef.current;
        const wrapper = wrapperRef.current;
        if (!table || !wrapper) return;
        const hasScrolled = wrapper && wrapper.scrollWidth - wrapper.scrollLeft !== wrapper.scrollWidth;
        const isMostRight = Math.ceil(wrapper.scrollLeft + wrapper.clientWidth) >= wrapper.scrollWidth;
        if (hasScrolled) {
            table.style.setProperty((0, $90747fbed8ccb7bc$export$542fcaf4d32961fd), `linear-gradient(90deg, ${"var(--ds-border, #0B120E24)"} 0%, rgba(0,0,0,0) 100%)`);
            table.style.setProperty((0, $90747fbed8ccb7bc$export$148cdd14db5d3c42), isMostRight ? 'none' : `linear-gradient(270deg, ${"var(--ds-border, #0B120E24)"} 0%, rgba(0,0,0,0) 100%)`);
        } else table.style.setProperty((0, $90747fbed8ccb7bc$export$542fcaf4d32961fd), 'none');
    }, [
        tableRef,
        wrapperRef
    ]);
    // Set up ResizeObserver for right pinning background when table width changes
    (0, $42omo.useEffect)(()=>{
        const table = tableRef.current;
        const wrapper = wrapperRef.current;
        const tbody = tbodyRef.current;
        if (!table || !wrapper || !tbody) return;
        const resizeObserver = new ResizeObserver(()=>{
            const hasScrollBar = wrapper.scrollWidth > wrapper.clientWidth;
            if (hasScrollBar) table.style.setProperty((0, $90747fbed8ccb7bc$export$148cdd14db5d3c42), `linear-gradient(270deg, ${"var(--ds-border, #0B120E24)"} 0%, rgba(0,0,0,0) 100%)`);
            else table.style.setProperty((0, $90747fbed8ccb7bc$export$148cdd14db5d3c42), 'none');
        });
        // Observe the tbody element since column resizing changes the tbody's width
        resizeObserver.observe(tbody);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        tableRef,
        wrapperRef,
        tbodyRef
    ]);
    // Set up scroll listener for pinning styles
    (0, $42omo.useEffect)(()=>{
        const table = tableRef.current;
        const wrapper = wrapperRef.current;
        if (!charlieTableState.getIsSomeColumnsPinned() || !table || !wrapper) return;
        const unbind = wrapper ? (0, $fFa3V.bind)(wrapper, {
            type: 'scroll',
            listener: onScroll
        }) : undefined;
        return ()=>{
            unbind?.();
        };
    }, [
        charlieTableState,
        onScroll,
        tableRef,
        wrapperRef
    ]);
};



const $90747fbed8ccb7bc$export$4c4d2d5ba926bbe5 = '--table-height';
const $90747fbed8ccb7bc$export$542fcaf4d32961fd = '--pinning-background-left';
const $90747fbed8ccb7bc$export$148cdd14db5d3c42 = '--pinning-background-right';
const $90747fbed8ccb7bc$var$getLeftPinnedColumnsWidth = (charlieTableState)=>{
    const leftPinnedColumns = charlieTableState.getLeftVisibleLeafColumns();
    let totalWidth = 0;
    for (const column of leftPinnedColumns)totalWidth += column.getSize();
    return totalWidth;
};
const $90747fbed8ccb7bc$var$getRightPinnedColumnsWidth = (charlieTableState)=>{
    const rightPinnedColumns = charlieTableState.getRightVisibleLeafColumns();
    let totalWidth = 0;
    for (const column of rightPinnedColumns)totalWidth += column.getSize();
    return totalWidth;
};
const $90747fbed8ccb7bc$export$259756d262b54355 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ charlieTableState: charlieTableState, children: children, tableRef: tableRef, tbodyRef: tbodyRef, enableRowReorder: enableRowReorder = false, enableColumnReorder: enableColumnReorder = false, onDraggingRowEnd: onDraggingRowEnd, ...props }, ref)=>{
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRef = (0, $7ff93f675da7135b$export$74665b213cb5c4cf)(internalRef, ref);
    // calculate pinned column widths for autoscroll positioning
    const columnPinning = charlieTableState.getState().columnPinning;
    const columnSizing = charlieTableState.getState().columnSizing;
    const leftPinnedColumnsWidth = (0, $42omo.useMemo)(()=>$90747fbed8ccb7bc$var$getLeftPinnedColumnsWidth(charlieTableState), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        columnPinning?.left,
        columnSizing
    ]);
    const rightPinnedColumnsWidth = (0, $42omo.useMemo)(()=>$90747fbed8ccb7bc$var$getRightPinnedColumnsWidth(charlieTableState), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        columnPinning?.right,
        columnSizing
    ]);
    (0, $ce8210834985e75f$export$fa1aba135c313d2f)({
        tableRef: tableRef
    });
    (0, $a053f3fad785a567$export$4b14221c5f4ccf02)({
        tableRef: tableRef,
        wrapperRef: internalRef,
        tbodyRef: tbodyRef,
        charlieTableState: charlieTableState
    });
    (0, $697463b37f166953$export$435719ededc46a43)({
        wrapperRef: internalRef,
        enableColumnReorder: enableColumnReorder,
        enableRowReorder: enableRowReorder,
        leftPinnedColumnsWidth: leftPinnedColumnsWidth,
        rightPinnedColumnsWidth: rightPinnedColumnsWidth
    });
    (0, $40962bbf2bd8295b$export$602210aed46cbcc4)({
        tableRef: tableRef,
        charlieTableState: charlieTableState,
        enableColumnReorder: enableColumnReorder,
        enableRowReorder: enableRowReorder,
        onDraggingRowEnd: onDraggingRowEnd
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: mergedRef,
        ...props,
        children: children
    });
});



const $31f26c495b1eaadc$var$hitboxWidth = '12px';
const $31f26c495b1eaadc$var$dropTargetStyle = null;
const $31f26c495b1eaadc$var$resizerStyles = null;
const $31f26c495b1eaadc$var$resizingStyles = null;
const $31f26c495b1eaadc$var$pinnedColumnLeftStyle = null;
const $31f26c495b1eaadc$var$pinnedColumnRightStyle = null;
const $31f26c495b1eaadc$var$idleState = {
    type: 'idle'
};
const $31f26c495b1eaadc$var$draggingState = {
    type: 'dragging'
};
const $31f26c495b1eaadc$var$defaultAllowedEdges = [
    'left',
    'right'
]; /**
                                                        * __PragmaticHeadCell__
                                                        *
                                                        * EXPERIMENTAL HeadCell element that uses pragmatic dnd for certain actions. Still being worked on.
                                                        */ 
const $31f26c495b1eaadc$export$c447832d175e288a = ({ children: children, onColumnResizeDrag: onColumnResizeDrag, onColumnResizeEnd: onColumnResizeEnd, allowedEdges: allowedEdges = $31f26c495b1eaadc$var$defaultAllowedEdges, id: id, enableColumnReorder: enableColumnReorder = false, enableResizing: enableResizing = false, columnResizeMode: columnResizeMode = 'onChange', isPinningEdge: isPinningEdge, size: size, resizeColumnLabel: resizeColumnLabel, resizerRef: externalResizerRef, onResizeHandleHoverChange: onResizeHandleHoverChange, isDropAllowed: isDropAllowed, ...props })=>{
    const dropTargetRef = (0, $42omo.useRef)(null);
    const headRef = (0, $42omo.useRef)(null);
    const localResizerRef = (0, $42omo.useRef)(null);
    const resizerRef = externalResizerRef || localResizerRef;
    const [closestEdge, setClosestEdge] = (0, $42omo.useState)(null);
    const [state, setState] = (0, $42omo.useState)($31f26c495b1eaadc$var$idleState);
    (0, $2c69f07036c8e9be$export$8a7a954d8c91183)({
        enabled: enableColumnReorder,
        elementRef: headRef,
        dropTargetRef: dropTargetRef,
        allowedEdges: allowedEdges,
        getData: ()=>({
                id: id,
                type: 'item-column'
            }),
        canDrop: ({ source: source })=>source.data.type === 'item-column' && isDropAllowed({
                sourceColumnId: source.data.id,
                targetColumnId: id
            }),
        canMonitor: ({ source: source })=>source.data.type === 'item-column' && (0, $45acf452ad2feb70$export$4ef518c7050e21b)(source.element, headRef.current),
        onDragStart: ()=>{
            if (state.type !== 'resizing') setState($31f26c495b1eaadc$var$draggingState);
        },
        onDrag: (closestEdge, sourceElement, targetElement, sourceData)=>{
            if (state.type === 'resizing') return;
            if (!enableColumnReorder) return;
            const isSource = sourceElement === targetElement;
            if (isSource) {
                closestEdge != null && setClosestEdge(null);
                return;
            } // Check if the drop is allowed before showing the indicator
            if (isDropAllowed({
                sourceColumnId: sourceData?.id,
                targetColumnId: id
            })) setClosestEdge(closestEdge);
            else setClosestEdge(null);
        },
        onDragLeave: ()=>{
            setClosestEdge(null);
        },
        onDrop: ()=>{
            setClosestEdge(null);
        },
        onDragEnd: ()=>{
            setState($31f26c495b1eaadc$var$idleState);
        },
        dependencies: [
            id,
            state.type,
            closestEdge
        ]
    });
    (0, $42omo.useEffect)(()=>{
        if (!enableResizing) return;
        const handle = resizerRef.current;
        (0, $dRnqM.default)(handle);
        const header = headRef.current;
        (0, $dRnqM.default)(header);
        return (0, $4T4vf.draggable)({
            element: handle,
            getInitialData () {
                return {
                    type: 'column-resize'
                };
            },
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage }) {
                (0, $5X6QO.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                (0, $gZctg.preventUnhandled).start();
                const initialWidth = header.getBoundingClientRect().width;
                if (columnResizeMode === 'onEnd') // Mark the column as resizing without mutating sizing state.
                onColumnResizeDrag(initialWidth);
                setState({
                    type: 'resizing',
                    initialWidth: initialWidth,
                    deltaOffset: 0
                });
            },
            onDrag ({ location: location }) {
                const diffX = location.current.input.clientX - location.initial.input.clientX;
                (0, $dRnqM.default)(state.type === 'resizing');
                const { initialWidth: initialWidth } = state;
                const proposedWidth = initialWidth + diffX;
                if (columnResizeMode === 'onChange' || columnResizeMode === 'onChangeEnd') {
                    if (proposedWidth !== initialWidth) onColumnResizeDrag(proposedWidth);
                } else // onEnd mode: track delta offset for css transform, don't update state yet
                setState((prev)=>{
                    if (prev.type !== 'resizing') return prev;
                    return {
                        ...prev,
                        deltaOffset: diffX
                    };
                });
            },
            onDrop ({ location: location }) {
                (0, $gZctg.preventUnhandled).stop();
                if ((columnResizeMode === 'onEnd' || columnResizeMode === 'onChangeEnd') && state.type === 'resizing') {
                    // update the width state at the end of the resize
                    const diffX = location.current.input.clientX - location.initial.input.clientX;
                    const finalWidth = state.initialWidth + diffX;
                    onColumnResizeEnd(finalWidth);
                } else onColumnResizeEnd();
                setState($31f26c495b1eaadc$var$idleState);
            }
        });
    }, [
        state,
        onColumnResizeDrag,
        onColumnResizeEnd,
        enableResizing,
        resizerRef,
        columnResizeMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $b824b9b815d7a642$export$4e8024263ace498b), {
        ...props,
        ref: headRef,
        children: [
            children,
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: dropTargetRef,
                style: {
                    height: `var(${(0, $90747fbed8ccb7bc$export$4c4d2d5ba926bbe5)})`
                },
                className: (0, $gMc0m.default)([
                    "_kqswstnw _154ize3t _1ltvze3t _1xi2ze3t _1pby1nn1 _1e0cglyw"
                ]),
                children: closestEdge && enableColumnReorder && /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.default), {
                    edge: closestEdge,
                    type: "no-terminal"
                })
            }),
            isPinningEdge && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    isPinningEdge === 'left' && "_kqswstnw _154ize3t _1xi2ze3t _16r27p75 _aetrb3bt _18postnw _32rx196n _15l2ze3t _1qdg1j7e _z0aii2wt",
                    isPinningEdge === 'right' && "_kqswstnw _154ize3t _1ltvze3t _1s6k7z6m _1kt9b3bt _1cs8stnw _qnec196n _1aukidpf _kfgt1j7e _1mp4i2wt"
                ])
            }),
            enableResizing && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: resizerRef,
                role: "slider",
                tabIndex: 0,
                "aria-valuemin": size?.min,
                "aria-valuemax": size?.max,
                "aria-orientation": "horizontal",
                "aria-valuenow": size?.min && size?.max ? size?.value : undefined,
                "aria-label": resizeColumnLabel,
                onMouseEnter: ()=>{
                    onResizeHandleHoverChange?.(id);
                },
                onMouseLeave: ()=>{
                    onResizeHandleHoverChange?.(false);
                },
                onFocus: ()=>{
                    const header = headRef.current;
                    if (!header) return;
                    onColumnResizeDrag(header.getBoundingClientRect().width);
                },
                onKeyDown: (e)=>{
                    const header = headRef.current;
                    if (!header) return;
                    if ([
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(e.key)) {
                        e.preventDefault(); // avoid scrolling
                        let deltaX = 10;
                        if (e.key === 'ArrowLeft') deltaX = -10;
                        if (columnResizeMode === 'onEnd') {
                            if (state.type !== 'keyboardResizing') {
                                const initialWidth = header.getBoundingClientRect().width; // Mark the column as resizing without mutating sizing state.
                                onColumnResizeDrag(initialWidth);
                            } // onEnd: keep track of changes visually, commit on enter
                            setState((prev)=>{
                                if (prev.type === 'keyboardResizing') // already keyboard resizing, add to delta
                                return {
                                    ...prev,
                                    deltaOffset: prev.deltaOffset + deltaX
                                };
                                 // start keyboard resizing
                                const initialWidth = header.getBoundingClientRect().width;
                                return {
                                    type: 'keyboardResizing',
                                    initialWidth: initialWidth,
                                    deltaOffset: deltaX
                                };
                            });
                        } else {
                            // onChange and onChangeEnd: update immediately
                            const initialWidth = header.getBoundingClientRect().width;
                            onColumnResizeDrag(initialWidth + deltaX);
                        }
                    }
                    if (e.key === 'Enter' && state.type === 'keyboardResizing') {
                        e.preventDefault();
                        const finalWidth = state.initialWidth + state.deltaOffset;
                        onColumnResizeEnd(finalWidth);
                        setState($31f26c495b1eaadc$var$idleState);
                    }
                    if (e.key === 'Enter' && columnResizeMode === 'onChangeEnd') {
                        e.preventDefault();
                        const currentWidth = header.getBoundingClientRect().width;
                        onColumnResizeEnd(currentWidth);
                    }
                    if (e.key === 'Escape' && state.type === 'keyboardResizing') {
                        e.preventDefault();
                        onColumnResizeEnd();
                        setState($31f26c495b1eaadc$var$idleState);
                    }
                },
                onBlur: ()=>{
                    // discard keyboard resize changes on blur
                    if (state.type === 'keyboardResizing') {
                        onColumnResizeEnd();
                        setState($31f26c495b1eaadc$var$idleState);
                        return;
                    }
                    onColumnResizeEnd();
                },
                // outline none is needed here to prevent Jira style overrides from being applied
                style: {
                    height: `var(${(0, $90747fbed8ccb7bc$export$4c4d2d5ba926bbe5)})`,
                    outline: 'none',
                    // Adjust position to compensate for border width changes (1px vs 2px)
                    // This keeps the handle in the same visual position, preventing flicker
                    right: `var(--col-${id}-resizer-offset, 0px)`,
                    // use css transform for visual feedback during resize in 'onEnd' mode (mouse or keyboard)
                    ...(state.type === 'resizing' || state.type === 'keyboardResizing') && columnResizeMode === 'onEnd' && {
                        transform: `translateX(${state.deltaOffset}px)`
                    }
                },
                className: (0, $gMc0m.default)([
                    "_bfhk1j28 _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1bsb1crf _80om11mm _16jlidpf _kqswstnw _1pby1nn1 _1xi2ze3t _154ize3t _94n5ze3t",
                    (state.type === 'resizing' || state.type === 'keyboardResizing') && "_80omn7od"
                ])
            })
        ]
    });
};


const $2edea3b59dfb33bd$var$styles = {
    borderTopLeft: "_191wia51 _13li12b0",
    borderTopRight: "_t51zia51 _qrwq12b0",
    borderTopRightT26: "_qrwqpb1k",
    borderTopLeftT26: "_13lipb1k",
    PinnedColumn: "_kqsw1if8 _1pbyowjs",
    UnpinnedColumn: "_kqswh2mm",
    ColumnPadding: "_bozgu2gc",
    ColumnReorder: "_bozgze3t _80om1qgj",
    columnResponsive: "_16jlkb7n"
};
const $2edea3b59dfb33bd$export$dfa60aeb2051f459 = ({ labels: labels, tableType: tableType, charlieTableColumn: charlieTableColumn, charlieTableState: charlieTableState, index: index, enableResizing: enableResizing = false, columnResizeMode: columnResizeMode = 'onChange', enableColumnReorder: enableColumnReorder, hasWidths: hasWidths, xcss: xcss, analyticsContext: analyticsContext, interactionName: interactionName, enableColumnActions: enableColumnActions, enableRowVirtualization: enableRowVirtualization, responsiveColumnSizing: responsiveColumnSizing, columnActions: columnActions, onColumnSizingChangeRef: onColumnSizingChangeRef, onResizeHandleHoverChange: onResizeHandleHoverChange })=>{
    // Evaluate enableColumnActions - supports boolean, config object, or function
    const evaluatedColumnActions = (0, $42omo.useMemo)(()=>{
        if (typeof enableColumnActions === 'function') // Function: call it with the column to get boolean or config
        return enableColumnActions(charlieTableColumn.column);
        // Direct value: boolean or config object
        return enableColumnActions;
    }, [
        enableColumnActions,
        charlieTableColumn.column
    ]);
    // Determine if column actions are enabled and merge configurations
    const { isEnabled: isEnabled, config: config } = (0, $42omo.useMemo)(()=>{
        // If evaluatedColumnActions is false or undefined, disable
        if (evaluatedColumnActions === false || evaluatedColumnActions === undefined) return {
            isEnabled: false,
            config: (0, $adc7b445c434f850$export$d1515a09b274390f)
        };
        // If evaluatedColumnActions is true, enable with merged config
        if (evaluatedColumnActions === true) return {
            isEnabled: true,
            config: {
                ...(0, $adc7b445c434f850$export$d1515a09b274390f),
                ...columnActions
            }
        };
        // If evaluatedColumnActions is a config object, enable with that config
        // Still merge with deprecated columnActions for backward compatibility
        return {
            isEnabled: true,
            config: {
                ...(0, $adc7b445c434f850$export$d1515a09b274390f),
                ...columnActions,
                ...evaluatedColumnActions
            }
        };
    }, [
        evaluatedColumnActions,
        columnActions
    ]);
    const mergedColumnActions = config;
    const isResponsive = responsiveColumnSizing?.(charlieTableColumn.column);
    const [isHoveringCell, setHoveringCell] = (0, $42omo.useState)(false);
    const [isSortButtonFocused, setSortButtonFocused] = (0, $42omo.useState)(false);
    const [isMoreActionsButtonFocused, setIsMoreActionsButtonFocused] = (0, $42omo.useState)(false);
    const [isDragHandlerFocused] = (0, $42omo.useState)(false);
    const isPinned = charlieTableColumn.column.getIsPinned();
    const columnMetadata = (0, $42omo.useMemo)(()=>({
            id: charlieTableColumn.id,
            canSort: charlieTableColumn.column.getCanSort(),
            canHide: charlieTableColumn.column.getCanHide(),
            isSorted: charlieTableColumn.column.getIsSorted(),
            isPinned: charlieTableColumn.column.getIsPinned(),
            index: charlieTableColumn.column.getIndex(),
            isFirstColumn: (position)=>charlieTableColumn.column.getIsFirstColumn(position),
            isLastColumn: (position)=>charlieTableColumn.column.getIsLastColumn(position)
        }), [
        charlieTableColumn
    ]);
    const allowedColumnActionMoves = (0, $42omo.useMemo)(()=>(0, $930143e73475a4c9$export$6fdecee97cc9f200)({
            column: columnMetadata,
            tableState: charlieTableState.getState()
        }), [
        columnMetadata,
        charlieTableState
    ]);
    const tableActions = (0, $42omo.useMemo)(()=>({
            toggleSorting: (desc)=>{
                charlieTableColumn.column.toggleSorting(desc);
            },
            clearSorting: ()=>{
                charlieTableColumn.column.clearSorting();
            },
            setColumnOrder: (order)=>{
                charlieTableState.setColumnOrderWithContext(order, {
                    trigger: 'menu'
                });
            },
            setColumnPinning: (pinning)=>{
                charlieTableState.setColumnPinning(pinning);
            },
            setColumnVisibility: (visibility)=>{
                charlieTableState.setColumnVisibility(visibility);
            },
            getState: ()=>charlieTableState.getState()
        }), [
        charlieTableColumn,
        charlieTableState
    ]);
    const isReserved = (0, $b2fd1883fd0c654d$export$f8b7ab5a32f0b337)(charlieTableColumn.id);
    // TODO: We probably don't need to be dependent on the enableColumnReorder prop here as it's more for dnd. But for now, we'll use it.
    const canColumnMove = (0, $42omo.useMemo)(()=>charlieTableState.getState().columnOrder.length > 0 ? !!allowedColumnActionMoves.size : enableColumnReorder && !isPinned, [
        charlieTableState,
        allowedColumnActionMoves,
        enableColumnReorder,
        isPinned
    ]);
    const canColumnReorderDnd = (0, $42omo.useMemo)(()=>enableColumnReorder && canColumnMove && !isReserved, [
        enableColumnReorder,
        canColumnMove,
        isReserved
    ]);
    const [isMoreActionsOpened, setMoreActionsOpened] = (0, $42omo.useState)(false);
    const Header = (0, $42omo.useMemo)(()=>{
        if ((enableResizing || canColumnReorderDnd) && !(0, $b2fd1883fd0c654d$export$f8b7ab5a32f0b337)(charlieTableColumn.id)) return 0, $31f26c495b1eaadc$export$c447832d175e288a;
        return 0, $b824b9b815d7a642$export$4e8024263ace498b;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enableResizing,
        canColumnMove
    ]);
    const sortDirection = charlieTableColumn.column.getIsSorted();
    const isLastLeftPinnedColumn = charlieTableColumn.column.getIsPinned() === 'left' && charlieTableColumn.column.getIsLastColumn('left');
    const isFirstRightPinnedColumn = charlieTableColumn.column.getIsPinned() === 'right' && charlieTableColumn.column.getIsFirstColumn('right');
    const showSortButton = isHoveringCell || isSortButtonFocused || isMoreActionsOpened;
    const showDragHandler = (isHoveringCell || isDragHandlerFocused) && !isReserved;
    const showMoreActionsButton = (isHoveringCell || isMoreActionsButtonFocused || isMoreActionsOpened) && !isReserved;
    const showColumnActions = isHoveringCell || showSortButton || showMoreActionsButton || charlieTableColumn.column.getIsSorted();
    const canColumnSort = charlieTableColumn.column.getCanSort();
    const canMoveColumns = allowedColumnActionMoves.size > 0;
    const isPinnedColumn = charlieTableColumn.column.getIsPinned();
    const isRightPinned = charlieTableState.getState().columnPinning?.right?.includes(charlieTableColumn.id);
    const canHideColumn = mergedColumnActions.hiding;
    const canPinColumn = mergedColumnActions.pinToLeft && !isRightPinned;
    const canMoveToFront = mergedColumnActions.moveToFront && canMoveColumns && !isPinnedColumn;
    const canMoveToBack = mergedColumnActions.moveToBack && canMoveColumns && !isPinnedColumn;
    const isMoreActionsEnabled = isEnabled && (canColumnSort || canMoveColumns || canPinColumn || canMoveToFront || canMoveToBack || canHideColumn);
    const { maxSize: maxSize, minSize: minSize } = charlieTableColumn.column.columnDef;
    let isPinningEdge;
    if (isLastLeftPinnedColumn) isPinningEdge = 'left';
    else if (isFirstRightPinnedColumn) isPinningEdge = 'right';
    else isPinningEdge = undefined;
    const shapeThemeRefresh = (0, $dh538.fg)('charlie-table-shape-refresh');
    return /*#__PURE__*/ (0, $42omo.createElement)(Header, {
        isOverridingResponsiveColumnSizing: responsiveColumnSizing != null,
        tableType: tableType,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            width: charlieTableColumn.getSize(),
            left: `var(--col-${charlieTableColumn.id}-left)`,
            right: `var(--col-${charlieTableColumn.id}-right)`,
            borderInlineEndWidth: `var(--col-${charlieTableColumn.id}-resizing-border-width, var(--col-${charlieTableColumn.id}-hover-border-width, ${shapeThemeRefresh && index === charlieTableState.getVisibleLeafColumns().length - 1 ? '0px' : tableType === 'INPUT' || index === charlieTableState.getVisibleLeafColumns().length - 1 ? "var(--ds-border-width, 1px)" : '0px'}))`,
            borderInlineEndColor: `var(--col-${charlieTableColumn.id}-resizing-border-color, var(--col-${charlieTableColumn.id}-hover-border-color, ${"var(--ds-border, #0B120E24)"}))`,
            paddingInlineStart: canColumnReorderDnd || isReserved ? '0px' : undefined
        },
        xcss: (0, $1Whri.cx)(isResponsive && $2edea3b59dfb33bd$var$styles.columnResponsive, isPinned ? $2edea3b59dfb33bd$var$styles.PinnedColumn : $2edea3b59dfb33bd$var$styles.UnpinnedColumn, canColumnReorderDnd && $2edea3b59dfb33bd$var$styles.ColumnReorder, // When shape-theme-default, wrapper has radius and top border; no corner or top border on header cells
        index === 0 && !shapeThemeRefresh && $2edea3b59dfb33bd$var$styles.borderTopLeft, index === charlieTableState.getVisibleLeafColumns().length - 1 && !shapeThemeRefresh && $2edea3b59dfb33bd$var$styles.borderTopRight, index === 0 && !shapeThemeRefresh && (0, $dh538.fg)('platform-dst-shape-theme-default') ? $2edea3b59dfb33bd$var$styles.borderTopLeftT26 : null, index === charlieTableState.getVisibleLeafColumns().length - 1 ? !shapeThemeRefresh && $2edea3b59dfb33bd$var$styles.borderTopRight : null, index === charlieTableState.getVisibleLeafColumns().length - 1 && !shapeThemeRefresh && (0, $dh538.fg)('platform-dst-shape-theme-default') ? $2edea3b59dfb33bd$var$styles.borderTopRightT26 : null, index && index === 0 && !canColumnReorderDnd ? $2edea3b59dfb33bd$var$styles.ColumnPadding : null, xcss),
        isPinningEdge: isPinningEdge,
        onColumnResizeDrag: (width)=>{
            if (columnResizeMode === 'onChange' || columnResizeMode === 'onChangeEnd') charlieTableState.setColumnSizing((old)=>({
                    ...old,
                    [charlieTableColumn.id]: width
                }));
            charlieTableState.setColumnSizingInfo((old)=>({
                    ...old,
                    isResizingColumn: charlieTableColumn.id
                }));
            // for onChange mode, call external callback on every drag
            if (columnResizeMode === 'onChange' && onColumnSizingChangeRef) {
                const newSizing = {
                    ...charlieTableState.getState().columnSizing,
                    [charlieTableColumn.id]: width
                };
                onColumnSizingChangeRef(newSizing);
            }
        },
        onColumnResizeEnd: (finalWidth)=>{
            if (columnResizeMode === 'onEnd' && finalWidth !== undefined) charlieTableState.setColumnSizing((old)=>({
                    ...old,
                    [charlieTableColumn.id]: finalWidth
                }));
            // for onEnd and onChangeEnd, call external callback at the end
            if ((columnResizeMode === 'onEnd' || columnResizeMode === 'onChangeEnd') && onColumnSizingChangeRef) {
                const currentSizing = charlieTableState.getState().columnSizing;
                // for onEnd, include the finalWidth since state was not updated yet
                const finalSizing = columnResizeMode === 'onEnd' && finalWidth !== undefined ? {
                    ...currentSizing,
                    [charlieTableColumn.id]: finalWidth
                } : currentSizing;
                onColumnSizingChangeRef(finalSizing);
            }
            charlieTableState.setColumnSizingInfo((old)=>({
                    ...old,
                    isResizingColumn: false
                }));
            onResizeHandleHoverChange?.(false);
        },
        ...sortDirection && {
            sortDirection: sortDirection === 'asc' ? 'ascending' : 'descending'
        },
        enableColumnReorder: canColumnReorderDnd,
        enableResizing: enableResizing,
        columnResizeMode: columnResizeMode,
        isDropAllowed: ({ sourceColumnId: sourceColumnId, targetColumnId: targetColumnId })=>(0, $a973082a70857008$export$6e195291211f6cda)({
                sourceColumnId: sourceColumnId,
                targetColumnId: targetColumnId,
                columnPinning: charlieTableState.getState().columnPinning
            }),
        width: hasWidths && (enableRowVirtualization || !charlieTableColumn.column.getIsLastColumn()) ? charlieTableColumn.getSize() : undefined,
        size: {
            min: minSize,
            max: maxSize,
            value: charlieTableColumn.getSize()
        },
        key: charlieTableColumn.id,
        id: charlieTableColumn.id,
        onMouseMove: (e)=>(0, $b427ec7ae9ac75dc$export$31b5f58e3936ace6)(e, isHoveringCell, setHoveringCell),
        onMouseLeave: ()=>{
            if (isHoveringCell) setHoveringCell(false);
        },
        resizeColumnLabel: typeof labels.resizeColumn === 'function' ? labels.resizeColumn(charlieTableColumn) : labels.resizeColumn,
        onResizeHandleHoverChange: enableResizing ? onResizeHandleHoverChange : undefined
    }, /*#__PURE__*/ (0, $l998X.jsx)((0, $ccbb2f31a2ffbcec$export$dd48657eabf73f1a), {
        charlieTableColumn: charlieTableColumn,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7446f1a1d137d808$export$8fcee14b42aad10f), {
                charlieTableColumn: charlieTableColumn,
                charlieTableState: charlieTableState,
                labels: labels,
                columnMetadata: columnMetadata,
                tableActions: tableActions,
                allowedColumnActionMoves: allowedColumnActionMoves,
                mergedColumnActions: mergedColumnActions,
                canColumnReorderDnd: !!canColumnReorderDnd,
                canColumnSort: !!canColumnSort,
                isMoreActionsEnabled: !!isMoreActionsEnabled,
                showDragHandler: showDragHandler,
                showSortButton: showSortButton,
                sortDirection: sortDirection,
                showColumnActions: !!showColumnActions,
                showMoreActionsButton: !!showMoreActionsButton,
                isMoreActionsOpened: !!isMoreActionsOpened,
                onToggleMoreActions: ()=>setMoreActionsOpened((prev)=>!prev),
                onMoreActionsClose: ()=>{
                    setMoreActionsOpened(false);
                    setHoveringCell(false);
                },
                onSortButtonFocusChange: setSortButtonFocused,
                onMoreActionsFocusChange: setIsMoreActionsButtonFocused,
                interactionName: interactionName,
                analyticsContext: analyticsContext,
                tooltipProps: tooltipProps
            })
    }));
};


const $ea545780393cf61b$var$styles = {
    row: "_1bsb1osq _1e0c1txw"
};
const $ea545780393cf61b$export$49949596304d8dbb = ({ headerGroup: headerGroup, table: table, enableRowVirtualization: enableRowVirtualization, labels: labels, enableResizing: enableResizing, columnResizeMode: columnResizeMode = 'onChange', tableType: tableType, enableColumnReorder: enableColumnReorder, hasWidths: hasWidths, headerCellXcss: headerCellXcss, enableColumnActions: enableColumnActions, responsiveColumnSizing: responsiveColumnSizing, columnVirtualizer: columnVirtualizer, columnActions: columnActions, onColumnSizingChangeRef: onColumnSizingChangeRef, onResizeHandleHoverChange: onResizeHandleHoverChange })=>{
    const { virtualColumns: virtualColumns, virtualPaddingLeft: virtualPaddingLeft, virtualPaddingRight: virtualPaddingRight } = columnVirtualizer ?? {};
    const headers = virtualColumns ?? headerGroup.headers;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $625b1137a3549d0c$export$5582bd7183a5e873), {
        xcss: $ea545780393cf61b$var$styles.row,
        children: [
            virtualPaddingLeft ? //eslint-disable-next-line  @atlaskit/ui-styling-standard/enforce-style-prop
            /*#__PURE__*/ (0, $l998X.jsx)("th", {
                style: {
                    display: 'flex',
                    width: virtualPaddingLeft
                }
            }) : null,
            headers.map((headerOrVirtualHeader, idx)=>{
                const header = virtualColumns ? headerGroup.headers[headerOrVirtualHeader.index] : headerOrVirtualHeader;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $2edea3b59dfb33bd$export$dfa60aeb2051f459), {
                    enableRowVirtualization: enableRowVirtualization,
                    labels: labels,
                    charlieTableColumn: header,
                    index: idx,
                    enableResizing: enableResizing && header.column.getCanResize(),
                    columnResizeMode: columnResizeMode,
                    charlieTableState: table,
                    tableType: tableType,
                    enableColumnReorder: enableColumnReorder,
                    hasWidths: hasWidths,
                    xcss: headerCellXcss,
                    enableColumnActions: enableColumnActions,
                    responsiveColumnSizing: responsiveColumnSizing,
                    columnActions: columnActions,
                    onColumnSizingChangeRef: onColumnSizingChangeRef,
                    onResizeHandleHoverChange: onResizeHandleHoverChange
                }, header.id);
            }),
            virtualPaddingRight ? //eslint-disable-next-line  @atlaskit/ui-styling-standard/enforce-style-prop
            /*#__PURE__*/ (0, $l998X.jsx)("th", {
                style: {
                    display: 'flex',
                    width: virtualPaddingRight
                }
            }) : null
        ]
    }, headerGroup.id);
};


/* thead.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















const $4141997f3ce1510d$export$c4c2bc57f2e82919 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "thead",
        ...props,
        ref: ref,
        children: children
    });
});


const $99ca7fb9cfb1535b$var$styles = {
    THeadBase: "_1r04ze3t _19itglyw _kqsw1if8 _1pby1kze _1e0c11p5"
};
const $99ca7fb9cfb1535b$export$c4c2bc57f2e82919 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, xcss: xcss, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4141997f3ce1510d$export$c4c2bc57f2e82919), {
        xcss: (0, $1Whri.cx)($99ca7fb9cfb1535b$var$styles.THeadBase, xcss),
        ref: ref,
        ...props,
        children: children
    });
});


/* load-more.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $ccHMk = parcelRequire("ccHMk");












const $c90df90006716ef6$var$styles = {
    LoadMoreWrapperStyle: "_1pfhu2gc",
    LoadMoreContainer: "_1e0c1txw _4cvr1h6o _1bah1h6o _kqsw1if8 _1ltvze3t",
    LoadMoreContainerDisabled: "_lcxvglyw",
    EndIndicatorDivider: "_19itglyw _n7zl1uh4 _19pkv47k _1bsb9by0"
};
const $c90df90006716ef6$export$5ecaec9f8bdac0eb = ({ hasNext: hasNext, onLoadNext: onLoadNext, isLoading: isLoading, isEmptyState: isEmptyState, isError: isError, hidePaginationEndIndicator: hidePaginationEndIndicator, loadMoreLabel: loadMoreLabel, loadMore: loadMore })=>{
    if (hasNext == null || onLoadNext == null) return null;
    const shapeThemeRefresh = (0, $dh538.fg)('charlie-table-shape-refresh');
    return !shapeThemeRefresh ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($c90df90006716ef6$var$styles.LoadMoreContainer, !hasNext && $c90df90006716ef6$var$styles.LoadMoreContainerDisabled),
        children: hasNext && onLoadNext ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $c90df90006716ef6$var$styles.LoadMoreWrapperStyle,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                testId: "prev-page-test-id",
                isLoading: isLoading,
                onClick: ()=>{
                    onLoadNext();
                },
                "aria-label": loadMoreLabel,
                spacing: "compact",
                children: loadMore
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: !(isEmptyState || isError || hidePaginationEndIndicator) && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "hr",
                testId: "table-footer-divider",
                xcss: $c90df90006716ef6$var$styles.EndIndicatorDivider,
                role: "presentation"
            })
        })
    }) : null;
};


/* loading.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




var $iXCQx = parcelRequire("iXCQx");




const $763c22fe9b46f79e$var$styles = {
    loadingIndicator: "_2rko12b0 _4cvr1h6o _16jlidpf _bfhk1aqn _16qs130s _1q51u2gc _85i5u2gc _bozgu2gc _y4tiu2gc _6rthpxbi",
    loadingContainer: "_1bsb1osq _kqswstnw _1bah1h6o _4cvr1h6o _94n5ze3t"
};
const $763c22fe9b46f79e$export$669f6ea7d267feaf = ({ label: label = 'Loading more' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: $763c22fe9b46f79e$var$styles.loadingContainer,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            xcss: $763c22fe9b46f79e$var$styles.loadingIndicator,
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                    size: "small",
                    appearance: "invert"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.inverse",
                    children: label
                })
            ]
        })
    });


/* table.tsx generated by @compiled/babel-plugin v0.36.1 */ 

















const $1d1966adcd11a0a1$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "table",
        testId: testId,
        ref: ref,
        ...props,
        children: children
    });
});


const $4f6fa582bc523af5$var$styles = {
    table: "_1reoewfl _18m9ewfl _1e0c11p5"
};
const $4f6fa582bc523af5$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId, xcss: xcss, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1d1966adcd11a0a1$export$54ec01a60f47d33d), {
        testId: testId,
        xcss: (0, $1Whri.cx)($4f6fa582bc523af5$var$styles.table, xcss),
        ref: ref,
        ...props,
        children: children
    });
});


const $cced208a2ca2846f$export$ab4f92552796fc83 = {
    sortLabel: (column)=>{
        const { header: header } = column.column.columnDef;
        if (typeof header === 'function') {
            const headerText = header(column.getContext());
            return typeof headerText === 'string' ? headerText : column.id;
        }
        return typeof header === 'string' ? header : column.id;
    },
    selectAllRows: 'Select all rows',
    selectRow: 'Select row',
    expandRow: 'Expand row',
    loadMore: 'Load more',
    loadMoreLabel: 'Load more rows',
    sortGroup: 'Sort options',
    sortAscending: 'Sort ascending',
    sortDescending: 'Sort descending',
    clearSorting: 'Clear sorting',
    resizeColumn: (column)=>`Resize column: ${column.id}`,
    moreActions: (column)=>`More actions for ${column.id} column`,
    moveColumnGroup: 'Move column options',
    moveColumnLeft: 'Move column to left',
    moveColumnRight: 'Move column to right',
    moveColumnFirst: 'Move column to first in table',
    moveColumnLast: 'Move column to last in table',
    columnVisibilityGroup: 'Column visibility options',
    pinColumn: 'Pin column',
    unpinColumn: 'Unpin column',
    hideColumn: 'Hide column'
};


const $3f27a437c3448a4c$export$6b697f6843ef11c5 = {
    createTable: (table)=>{
        table.setColumnOrderWithContext = (updater, context)=>{
            table.options.onColumnOrderChange?.(updater, context);
        };
    }
};






function $e1bc253c7b472c7e$export$bfbd9b66604b8ad8({ table: table, columnSizing: columnSizing, columnSizingInfo: columnSizingInfo, tableType: tableType, tableRef: tableRef }) {
    const hoveredResizeColumnIdRef = (0, $42omo.useRef)(false);
    // CSS vars for pinned columns positioning
    const columnCssVars = (0, $42omo.useMemo)(()=>{
        const cols = table.getAllLeafColumns();
        const colCss = {};
        cols.forEach((col)=>{
            const isPinned = col.getIsPinned();
            if (!isPinned || !col) return;
            const colKeyPrefix = `--col-${col.id}`;
            colCss[`${colKeyPrefix}-left`] = isPinned === 'left' ? `${col.getStart('left')}px` : undefined;
            colCss[`${colKeyPrefix}-right`] = isPinned === 'right' ? `${col.getAfter('right')}px` : undefined;
            colCss[`${colKeyPrefix}-zIndex`] = '200';
            colCss[`${colKeyPrefix}-position`] = 'sticky';
        });
        if (table?.getState()?.columnPinning?.left && table.getState().columnPinning.left.length > 0 || table?.getState()?.columnPinning?.right && table.getState().columnPinning.right.length > 0) colCss[`--col-group-position`] = 'sticky';
        return colCss;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        table.options.state
    ]);
    // CSS vars for column sizes
    const columnSizeVars = (0, $42omo.useMemo)(()=>{
        const cols = table.getAllLeafColumns();
        const colCss = {};
        cols.forEach((col)=>{
            colCss[`--col-${col.id}-size`] = `${col.getSize()}px`;
        });
        return colCss;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        table.options.state,
        columnSizing
    ]);
    // CSS vars for resize state (only for actively resizing column)
    const columnResizeVars = (0, $42omo.useMemo)(()=>{
        const colCss = {};
        const resizingColumnId = columnSizingInfo.isResizingColumn;
        // Only set CSS vars for the column being actively resized (not hover)
        // Hover is handled via direct DOM manipulation to avoid re-renders
        if (resizingColumnId) {
            colCss[`--col-${resizingColumnId}-resizing-border-block-end-color`] = 'transparent';
            colCss[`--col-${resizingColumnId}-resizing-border-width`] = '2px';
            colCss[`--col-${resizingColumnId}-resizing-border-color`] = "var(--ds-border-brand, #1868DB)";
            // Adjust resize handle position to compensate for border width change
            // Input tables: 1px → 2px = -1px offset
            // Inventory tables: 0px → 2px = -2px offset
            const offsetPx = tableType === (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).input ? '-1px' : '-2px';
            colCss[`--col-${resizingColumnId}-resizer-offset`] = offsetPx;
        }
        return colCss;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        table.options.state,
        columnSizingInfo,
        tableType
    ]);
    /**
   * Handles hover state for resize handles using direct DOM manipulation.
   * This bypasses React's render cycle, preventing re-renders on every hover.
   * The border and position offset are applied directly to the table element's style.
   */ const handleResizeHandleHoverChange = (0, $42omo.useCallback)((columnId)=>{
        const tableEl = tableRef.current;
        if (!tableEl) return;
        // Clear previous hover styles
        const prevId = hoveredResizeColumnIdRef.current;
        if (prevId) {
            tableEl.style.removeProperty(`--col-${prevId}-hover-border-width`);
            tableEl.style.removeProperty(`--col-${prevId}-hover-border-color`);
            tableEl.style.removeProperty(`--col-${prevId}-resizer-offset`);
        }
        // Set new hover styles
        if (columnId) {
            tableEl.style.setProperty(`--col-${columnId}-hover-border-width`, '2px');
            tableEl.style.setProperty(`--col-${columnId}-hover-border-color`, "var(--ds-border, #0B120E24)");
            // Compensate for border width change to prevent layout shift
            const offsetPx = tableType === (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).input ? '-1px' : '-2px';
            tableEl.style.setProperty(`--col-${columnId}-resizer-offset`, offsetPx);
        }
        hoveredResizeColumnIdRef.current = columnId;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tableType
    ]);
    return {
        columnCssVars: columnCssVars,
        columnSizeVars: columnSizeVars,
        columnResizeVars: columnResizeVars,
        handleResizeHandleHoverChange: handleResizeHandleHoverChange
    };
}






var $9Jrw1 = parcelRequire("9Jrw1");



const $f0b0aba87c8c9112$export$941f79eb3ff43f0f = ({ enableColumnVirtualization: enableColumnVirtualization, enableColumnPinning: enableColumnPinning, table: table, tableContainerRef: tableContainerRef, columnVirtualizerOptions: columnVirtualizerOptions })=>{
    /**
	 * This theoretically breaks the rule of hooks but the prop can't be changed after the table is rendered
	 * so in practice it's fine
	 */ if (!enableColumnVirtualization) return undefined;
    const { columnPinning: columnPinning, columnVisibility: columnVisibility } = table.getState();
    const visibleColumns = table.getAllLeafColumns();
    const customColumnVirtualizerOptions = typeof columnVirtualizerOptions === 'function' ? columnVirtualizerOptions({
        table: table
    }) : columnVirtualizerOptions;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [leftPinnedIndexes, rightPinnedIndexes] = (0, $42omo.useMemo)(()=>enableColumnPinning ? [
            table.getLeftVisibleLeafColumns().map((c)=>c.getPinnedIndex()),
            table.getRightVisibleLeafColumns().map((column)=>visibleColumns.length - column.getPinnedIndex() - 1).sort((a, b)=>a - b)
        ] : [
            [],
            []
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        columnPinning,
        columnVisibility,
        enableColumnPinning
    ]);
    const numPinnedLeft = leftPinnedIndexes.length;
    const numPinnedRight = rightPinnedIndexes.length;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const columnVirtualizer = (0, $gHR9M.useVirtualizer)({
        count: visibleColumns.length,
        estimateSize: (index)=>visibleColumns[index].getSize(),
        getScrollElement: ()=>tableContainerRef.current,
        horizontal: true,
        overscan: 5,
        // eslint-disable-next-line react-hooks/rules-of-hooks
        rangeExtractor: (0, $42omo.useCallback)((range)=>{
            const newIndexes = (0, $9Jrw1.defaultRangeExtractor)(range);
            if (!numPinnedLeft && !numPinnedRight) return newIndexes;
            // need to ensure that the pinned columns are always included
            return [
                ...new Set([
                    ...leftPinnedIndexes,
                    ...newIndexes,
                    ...rightPinnedIndexes
                ])
            ];
        }, [
            leftPinnedIndexes,
            rightPinnedIndexes,
            numPinnedLeft,
            numPinnedRight
        ]),
        ...customColumnVirtualizerOptions
    });
    const virtualColumns = columnVirtualizer.getVirtualItems();
    const numColumns = virtualColumns.length;
    let virtualPaddingLeft = 0;
    let virtualPaddingRight = 0;
    // need to calculate the padding to take into account the pinned columns
    if (numColumns) {
        const totalSize = columnVirtualizer.getTotalSize();
        const leftNonPinnedStart = virtualColumns[numPinnedLeft]?.start || 0;
        const leftNonPinnedEnd = virtualColumns[leftPinnedIndexes.length - 1]?.end || 0;
        const rightNonPinnedStart = virtualColumns[numColumns - numPinnedRight]?.start || 0;
        const rightNonPinnedEnd = virtualColumns[numColumns - numPinnedRight - 1]?.end || 0;
        virtualPaddingLeft = leftNonPinnedStart - leftNonPinnedEnd;
        virtualPaddingRight = totalSize - rightNonPinnedEnd - (numPinnedRight ? totalSize - rightNonPinnedStart : 0);
    }
    return {
        virtualColumns: virtualColumns ?? undefined,
        virtualPaddingLeft: virtualPaddingLeft,
        virtualPaddingRight: virtualPaddingRight
    };
};



var $j1Hga = parcelRequire("j1Hga");

const $aa574ad689e4e387$export$bf05ea458ce043ed = ({ containerRefElement: containerRefElement, onScrollTo: onScrollTo, tableState: tableState })=>{
    if (containerRefElement) {
        const { scrollHeight: scrollHeight, scrollTop: scrollTop, clientHeight: clientHeight } = containerRefElement;
        //once the user has scrolled within 400px of the bottom of the table, fetch more data if we can
        if (scrollHeight - scrollTop - clientHeight < 400 && tableState !== (0, $j1Hga.TableState).loading) {
            onScrollTo();
            return true;
        }
    }
    return false;
};





function $a8928b58f5488ed5$export$bfec7ec94303aa98() {
    return (table)=>(0, $hvpsn.memo)(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            try {
                if (!rowModel.rows.length || !grouping.length) return rowModel;
                // Filter the grouping list down to columns that exist
                const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
                const groupedFlatRows = [];
                const groupedRowsById = {};
                // Recursively group the data
                const groupUpRecursively = (rows, depth = 0, parentId)=>{
                    // Grouping depth has been been met
                    // Stop grouping and simply rewrite thd depth and row relationships
                    if (depth >= existingGrouping.length) return rows.map((row)=>{
                        row.depth = depth;
                        groupedFlatRows.push(row);
                        groupedRowsById[row.id] = row;
                        if (row.subRows.length) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                        return row;
                    });
                    const columnId = existingGrouping[depth];
                    if (!columnId) throw new Error('Column not found');
                    return rows.map((row)=>{
                        const groupingValue = row.getGroupingValue(columnId);
                        const id = row.id;
                        const subRows = groupUpRecursively(row.subRows, depth + 1, id);
                        const leafRows = depth ? (0, $hvpsn.flattenBy)(row.subRows, (row)=>row.subRows) : row.subRows;
                        const groupedRow = (0, $hvpsn.createRow)(table, id, row.original, 0, depth, undefined, parentId);
                        return Object.assign(groupedRow, {
                            groupingColumnId: columnId,
                            groupingValue: groupingValue,
                            subRows: subRows,
                            leafRows: leafRows
                        });
                    });
                };
                const groupedRows = groupUpRecursively(rowModel.rows, 0);
                groupedRows.forEach((subRow)=>{
                    groupedFlatRows.push(subRow);
                    groupedRowsById[subRow.id] = subRow;
                });
                return {
                    rows: groupedRows,
                    flatRows: groupedFlatRows,
                    rowsById: groupedRowsById
                };
            } catch  {
                return rowModel;
            }
        }, (0, $hvpsn.getMemoOptions)(table.options, 'debugTable', 'getGroupedRowModel', ()=>{
            table._queue(()=>{
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
}
















const $9b23c35bffe0b104$export$a8d08eb9e6ca905 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ charlieTableState: charlieTableState, children: children, tableRef: tableRef, tbodyRef: tbodyRef, ...props }, ref)=>{
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRef = (0, $7ff93f675da7135b$export$74665b213cb5c4cf)(internalRef, ref);
    (0, $ce8210834985e75f$export$fa1aba135c313d2f)({
        tableRef: tableRef
    });
    (0, $a053f3fad785a567$export$4b14221c5f4ccf02)({
        tableRef: tableRef,
        wrapperRef: internalRef,
        tbodyRef: tbodyRef,
        charlieTableState: charlieTableState
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: mergedRef,
        ...props,
        children: children
    });
});


const $01f7e1a0fa31531b$var$styles = {
    LoadingTable: "_tzy4n2vs _lcxvglyw",
    TableWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug _c71l1kxc _kqswh2mm _19121cl4 _1e0c1txw _1pbyidpf _2lx21bp4 _4t3i1osq _13li12b0 _qrwq12b0",
    TableWrapperT26: "_13lipb1k _qrwqpb1k",
    Table: "_yq5hus1c _btyzidpf _1bsb1osq _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    FixedTableLayout: "_1kqm1n9t",
    AutoTableLayout: "_1kqm1wug",
    LoadingOverlayStyle: "_kqswstnw _1bah1h6o _4cvr1h6o _lcxvglyw _154ize3t _1ltvze3t _1xi2ze3t _94n5ze3t",
    OuterBorder: "_19itia51 _1reo15vq _18m915vq _13lipb1k _qrwqpb1k _mrkbpb1k _1o0zpb1k _kqswh2mm",
    StatusBarWrapper: "_x3doia51 _bfhkvuon _1bsb1osq"
};
const $01f7e1a0fa31531b$export$3d6dc94c3b008646 = {
    loaded: 'LOADED',
    loading: 'LOADING',
    error: 'ERROR'
};
const $01f7e1a0fa31531b$var$Caption = ({ tableCaption: tableCaption })=>{
    if (!tableCaption) return null;
    if (typeof tableCaption === 'function') return tableCaption();
    return /*#__PURE__*/ (0, $l998X.jsx)("caption", {
        children: tableCaption
    });
};
const $01f7e1a0fa31531b$export$653047d99c89ec70 = ({ labels: // Any tanstack params set as a default here needs to be added to the hook below
labels = (0, $cced208a2ca2846f$export$ab4f92552796fc83), manualSorting: manualSorting = true, manualPagination: manualPagination = true, enableRowReorder: enableRowReorder = false, enableResizing: enableResizing = false, columnResizeMode: columnResizeMode = 'onChange', tableType: tableType = (0, $ed0a2f88b068d47d$export$ec659152c0ce3638).input, tableState: tableState = $01f7e1a0fa31531b$export$3d6dc94c3b008646.loaded, rowSpacing: rowSpacing = 'default', rowCellXcss: rowCellXcss, headerCellXcss: headerCellXcss, tableWrapperXcss: tableWrapperXcss, enableSortingRemoval: enableSortingRemoval = false, enableKeyboardNavigation: enableKeyboardNavigation = false, enableRowVirtualization: enableRowVirtualizationProp = false, enableColumnVirtualization: enableColumnVirtualizationProp = false, tableCaption: tableCaption, responsiveColumnSizing: responsiveColumnSizing, ...props })=>{
    // Can't be changed after the table is rendered
    const enableRowVirtualization = (0, $42omo.useMemo)(()=>enableRowVirtualizationProp, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const enableColumnVirtualization = (0, $42omo.useMemo)(()=>enableColumnVirtualizationProp, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Ensure that the labels are always defined
    const allLabels = {
        ...(0, $cced208a2ca2846f$export$ab4f92552796fc83),
        ...labels
    };
    const tableRef = (0, $42omo.useRef)(null);
    (0, $42omo.useImperativeHandle)(props.refs?.tableRef, ()=>tableRef.current);
    const containerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useImperativeHandle)(props.refs?.tableContainerRef, ()=>containerRef.current);
    /**
   * Set to true synchronously in the scroll handler when it triggers `onLoadNext`.
   * Cleared during render once `tableState` is no longer loading so it doesn't
   * linger and incorrectly show the indicator for a future non-scroll-triggered load.
   */ const scrollTriggeredLoadRef = (0, $42omo.useRef)(false);
    if (tableState !== $01f7e1a0fa31531b$export$3d6dc94c3b008646.loading) scrollTriggeredLoadRef.current = false;
    const showLoadingMoreFromScroll = tableState === $01f7e1a0fa31531b$export$3d6dc94c3b008646.loading && scrollTriggeredLoadRef.current;
    const tbodyRef = (0, $42omo.useRef)(null);
    (0, $42omo.useImperativeHandle)(props.refs?.tableBodyRef, ()=>tbodyRef.current);
    const { tableNavigationControllers: tableNavigationControllers } = (0, $fmn3m.useKeyboardNavigation)();
    const lastSelectedRowIdRef = (0, $42omo.useRef)(null);
    const CharlieWrapper = (0, $42omo.useMemo)(()=>{
        if (props.enableColumnReorder || enableRowReorder || enableResizing) return 0, $90747fbed8ccb7bc$export$259756d262b54355;
        return 0, $9b23c35bffe0b104$export$a8d08eb9e6ca905;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.enableColumnReorder,
        enableRowReorder,
        enableResizing
    ]);
    const reservedColumnConfigs = (0, $42omo.useMemo)(()=>{
        const configs = [];
        if (props.enableRowSelection) {
            const checkboxConfig = (0, $b2fd1883fd0c654d$export$d5bdb168897a18dd)({
                id: (0, $b2fd1883fd0c654d$export$a8fe87a68ec18bbd).CHECKBOX,
                feature: 'checkbox',
                position: 'start',
                labels: {
                    selectRow: allLabels.selectRow,
                    selectAllRows: allLabels.selectAllRows
                },
                analyticsContext: props.analyticsContext,
                lastSelectedRowIdRef: lastSelectedRowIdRef
            });
            configs.push(checkboxConfig);
        }
        return configs;
    }, [
        props.enableRowSelection,
        allLabels.selectRow,
        allLabels.selectAllRows,
        props.analyticsContext
    ]);
    const reservedColumnResult = (0, $42omo.useMemo)(()=>(0, $b2fd1883fd0c654d$export$c4724ea5fd313554)({
            reservedColumns: reservedColumnConfigs,
            originalColumns: props.columnDefs
        }), [
        reservedColumnConfigs,
        props.columnDefs
    ]);
    const tanModifiedColumns = (0, $42omo.useMemo)(()=>{
        if (!props.columnDefs) return undefined;
        return reservedColumnResult.modifiedColumns;
    }, [
        props.columnDefs,
        reservedColumnResult.modifiedColumns
    ]);
    const processedColumnStates = (0, $42omo.useMemo)(()=>(0, $b2fd1883fd0c654d$export$1bb60ea325c29252)(reservedColumnResult, {
            columnOrder: props.state?.columnOrder,
            columnPinningLeft: props.state?.columnPinning?.left
        }, {
            columnOrder: props.initialState?.columnOrder,
            columnPinningLeft: props.initialState?.columnPinning?.left
        }), [
        reservedColumnResult,
        props.state?.columnOrder,
        props.state?.columnPinning?.left,
        props.initialState?.columnOrder,
        props.initialState?.columnPinning?.left
    ]);
    const { modifiedColumnOrder: modifiedColumnOrder, modifiedInitialColumnOrder: modifiedInitialColumnOrder, modifiedColumnPinningLeft: modifiedColumnPinningLeft, modifiedInitialColumnPinningLeft: modifiedInitialColumnPinningLeft } = processedColumnStates;
    const modifiedColumnPinning = (0, $42omo.useMemo)(()=>modifiedColumnPinningLeft ? {
            ...props.state?.columnPinning,
            left: modifiedColumnPinningLeft
        } : props.state?.columnPinning, [
        modifiedColumnPinningLeft,
        props.state?.columnPinning
    ]);
    const modifiedInitialColumnPinning = (0, $42omo.useMemo)(()=>modifiedInitialColumnPinningLeft ? {
            ...props.initialState?.columnPinning,
            left: modifiedInitialColumnPinningLeft
        } : props.initialState?.columnPinning, [
        modifiedInitialColumnPinningLeft,
        props.initialState?.columnPinning
    ]);
    const stableEmptyTanArray = (0, $42omo.useMemo)(()=>[], []);
    const columns = (0, $42omo.useMemo)(()=>tanModifiedColumns ?? [], [
        tanModifiedColumns
    ]);
    const memoedData = (0, $42omo.useMemo)(()=>props.data ?? stableEmptyTanArray, [
        props.data,
        stableEmptyTanArray
    ]);
    // extract external callback to manually call based on columnResizeMode
    const onColumnSizingChangeRef = (0, $42omo.useRef)(props.onColumnSizingChange);
    onColumnSizingChangeRef.current = props.onColumnSizingChange;
    const { onColumnSizingChange: _, ...propsWithoutSizingCallback } = props;
    const table = (0, $bVEgZ.useReactTable)({
        ...propsWithoutSizingCallback,
        _features: [
            (0, $3f27a437c3448a4c$export$6b697f6843ef11c5),
            ...props._features ?? []
        ],
        defaultColumn: {
            ...props.defaultColumn,
            // setting a min size of 26 here to avoid breaking styling when columns are too small
            minSize: Math.max(26, props.defaultColumn?.minSize ?? 0)
        },
        columns: columns,
        data: memoedData,
        autoResetExpanded: props.autoResetExpanded,
        state: {
            ...props.state,
            ...modifiedColumnPinning && {
                columnPinning: modifiedColumnPinning
            },
            ...modifiedColumnOrder && {
                columnOrder: modifiedColumnOrder
            }
        },
        initialState: {
            ...props.initialState,
            ...modifiedInitialColumnPinning && {
                columnPinning: modifiedInitialColumnPinning
            },
            ...modifiedInitialColumnOrder && {
                columnOrder: modifiedInitialColumnOrder
            }
        },
        enableSortingRemoval: enableSortingRemoval,
        enableRowSelection: props.enableRowSelection,
        getCoreRowModel: (0, $hvpsn.getCoreRowModel)(),
        getExpandedRowModel: (0, $hvpsn.getExpandedRowModel)(),
        getGroupedRowModel: props.enableServerSideGrouping ? (0, $a8928b58f5488ed5$export$bfec7ec94303aa98)() : (0, $hvpsn.getGroupedRowModel)(),
        getSortedRowModel: (0, $hvpsn.getSortedRowModel)(),
        manualSorting: manualSorting,
        manualPagination: manualPagination
    });
    (0, $42omo.useImperativeHandle)(props.refs?.internalTableRef, ()=>table, [
        table
    ]);
    const { columnSizing: columnSizing, columnSizingInfo: columnSizingInfo } = table.getState();
    const hasWidths = Object.keys(columnSizing ?? {}).length > 0 || enableResizing;
    const { columnCssVars: columnCssVars, columnSizeVars: columnSizeVars, columnResizeVars: columnResizeVars, handleResizeHandleHoverChange: handleResizeHandleHoverChange } = (0, $e1bc253c7b472c7e$export$bfbd9b66604b8ad8)({
        table: table,
        columnSizing: columnSizing,
        columnSizingInfo: columnSizingInfo,
        tableType: tableType,
        tableRef: tableRef
    });
    const isEmptyState = table.options.data.length === 0 && tableState === $01f7e1a0fa31531b$export$3d6dc94c3b008646.loaded;
    const columnVirtualizer = (0, $f0b0aba87c8c9112$export$941f79eb3ff43f0f)({
        table: table,
        enableColumnVirtualization: enableColumnVirtualization,
        enableColumnPinning: table.getIsSomeColumnsPinned(),
        tableContainerRef: containerRef,
        columnVirtualizerOptions: props.columnVirtualizerOptions
    });
    const commonTableBodyProps = {
        table: table,
        rowSpacing: rowSpacing,
        tableType: tableType,
        rowCellXcss: rowCellXcss,
        labels: allLabels,
        renderOptions: props.renderOptions,
        enableRowSelection: props.enableRowSelection,
        onRowClick: props.onRowClick,
        interactionName: props.interactionName,
        renderChildComponent: props.renderChildComponent,
        analyticsContext: props.analyticsContext,
        tableBodyRef: tbodyRef,
        enableRowVirtualization: enableRowVirtualization,
        enableKeyboardNavigation: enableKeyboardNavigation,
        tableNavigationControllers: tableNavigationControllers,
        containerRef: containerRef,
        rowVirtualizerRef: props.refs?.rowVirtualizerRef,
        rowVirtualizerOptions: props.rowVirtualizerOptions,
        responsiveColumnSizing: responsiveColumnSizing,
        columnVirtualizer: columnVirtualizer,
        enableRowReorder: enableRowReorder,
        onDraggingRowEnd: props.onDraggingRowEnd,
        componentPropOverrides: props.componentPropOverrides
    };
    const isColumnSizing = columnSizingInfo.isResizingColumn !== false;
    const shapeThemeRefresh = (0, $dh538.fg)('charlie-table-shape-refresh');
    const scrollableContent = /*#__PURE__*/ (0, $l998X.jsxs)(CharlieWrapper, {
        xcss: (0, $1Whri.cx)($01f7e1a0fa31531b$var$styles.TableWrapper, tableWrapperXcss, !shapeThemeRefresh && (0, $dh538.fg)('platform-dst-shape-theme-default') && $01f7e1a0fa31531b$var$styles.TableWrapperT26),
        ref: containerRef,
        testId: `charlie-table-scrollable-content${props.testId ? `-${props.testId}` : ''}`,
        ...props.hasNext && props.onLoadNext != null && {
            onScroll: (event)=>{
                const didTriggerLoad = (0, $aa574ad689e4e387$export$bf05ea458ce043ed)({
                    containerRefElement: event.currentTarget,
                    onScrollTo: props.onLoadNext,
                    tableState: tableState
                });
                if (didTriggerLoad) scrollTriggeredLoadRef.current = true;
            }
        },
        ...props.enableColumnReorder || enableRowReorder || enableResizing ? {
            charlieTableState: table,
            tableRef: tableRef,
            tbodyRef: tbodyRef,
            enableRowReorder: enableRowReorder,
            enableColumnReorder: props.enableColumnReorder,
            onDraggingRowEnd: props.onDraggingRowEnd
        } : {
            charlieTableState: table,
            tableRef: tableRef,
            tbodyRef: tbodyRef
        },
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $4f6fa582bc523af5$export$54ec01a60f47d33d), {
                "aria-label": labels?.table,
                testId: props.testId,
                ref: tableRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    ...columnCssVars,
                    ...columnSizeVars,
                    ...columnResizeVars
                },
                xcss: (0, $1Whri.cx)(tableState === $01f7e1a0fa31531b$export$3d6dc94c3b008646.loading && (!showLoadingMoreFromScroll || !shapeThemeRefresh) ? $01f7e1a0fa31531b$var$styles.LoadingTable : false, $01f7e1a0fa31531b$var$styles.Table, hasWidths && !enableRowVirtualization ? $01f7e1a0fa31531b$var$styles.FixedTableLayout : $01f7e1a0fa31531b$var$styles.AutoTableLayout),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($01f7e1a0fa31531b$var$Caption, {
                        tableCaption: tableCaption
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $99ca7fb9cfb1535b$export$c4c2bc57f2e82919), {
                        children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $ea545780393cf61b$export$49949596304d8dbb), {
                                headerGroup: headerGroup,
                                table: table,
                                enableRowVirtualization: enableRowVirtualization,
                                labels: allLabels,
                                enableResizing: enableResizing,
                                columnResizeMode: columnResizeMode,
                                tableType: tableType,
                                enableColumnReorder: props.enableColumnReorder,
                                hasWidths: hasWidths,
                                headerCellXcss: headerCellXcss,
                                enableColumnActions: props.enableColumnActions,
                                responsiveColumnSizing: responsiveColumnSizing,
                                columnVirtualizer: columnVirtualizer,
                                columnActions: props.columnActions,
                                onColumnSizingChangeRef: onColumnSizingChangeRef.current,
                                onResizeHandleHoverChange: handleResizeHandleHoverChange
                            }, headerGroup.id))
                    }),
                    !enableRowVirtualization && !enableColumnVirtualization || isColumnSizing ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6490284aedfa7015$export$fe4b3545202378aa), {
                        ...commonTableBodyProps
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6490284aedfa7015$export$ccee973a9f6f53e3), {
                        ...commonTableBodyProps
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $c90df90006716ef6$export$5ecaec9f8bdac0eb), {
                hasNext: props.hasNext,
                onLoadNext: props.onLoadNext,
                isLoading: tableState === $01f7e1a0fa31531b$export$3d6dc94c3b008646.loading,
                isEmptyState: isEmptyState,
                isError: tableState === $01f7e1a0fa31531b$export$3d6dc94c3b008646.error,
                hidePaginationEndIndicator: props.hidePaginationEndIndicator,
                loadMoreLabel: allLabels.loadMoreLabel ?? 'Load more rows',
                loadMore: allLabels.loadMore ?? 'Load more'
            }),
            tableState === $01f7e1a0fa31531b$export$3d6dc94c3b008646.loading && !shapeThemeRefresh && /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                xcss: $01f7e1a0fa31531b$var$styles.LoadingOverlayStyle,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                    size: "large",
                    testId: "common-table-spinner"
                })
            }),
            tableState === $01f7e1a0fa31531b$export$3d6dc94c3b008646.error && props.errorView,
            isEmptyState && props.emptyTableView
        ]
    });
    const statusBarElement = props.statusBar != null ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $01f7e1a0fa31531b$var$styles.StatusBarWrapper,
        children: props.statusBar
    }) : null;
    return shapeThemeRefresh ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $01f7e1a0fa31531b$var$styles.OuterBorder,
        children: [
            scrollableContent,
            tableState === $01f7e1a0fa31531b$export$3d6dc94c3b008646.loading && showLoadingMoreFromScroll && /*#__PURE__*/ (0, $l998X.jsx)((0, $763c22fe9b46f79e$export$669f6ea7d267feaf), {
                label: allLabels.loadingMore
            }),
            statusBarElement
        ]
    }) : scrollableContent;
};
module.exports["TableState"] = $01f7e1a0fa31531b$export$3d6dc94c3b008646;
module.exports["CharlieTable"] = $01f7e1a0fa31531b$export$653047d99c89ec70;

});


$parcel$global.rlb("3lTxa")
//# sourceMappingURL=object-preview-panel.b21f499f.js.map
